export const translations = {
  // Navbar
  "nav.home": { ar: "الرئيسية", en: "Home" },
  "nav.map": { ar: "خريطة التراث", en: "Heritage Map" },
  "nav.search": { ar: "بحث المعرفة", en: "Knowledge Search" },
  "nav.provenance": { ar: "وثيق", en: "Watheeq" },
  "wq.name": { ar: "وثيق", en: "Watheeq" },
  "wq.subtitle": { ar: "توثيق محصول التمور", en: "Origin Trust" },
  "wq.tab.overview": { ar: "نظرة عامة", en: "Overview" },
  "wq.tab.new": { ar: "محصول جديد", en: "New Yield" },
  "wq.tab.timeline": { ar: "سجل المحاصيل", en: "Yields Timeline" },
  "wq.tab.wallet": { ar: "محفظة الشهادات", en: "Certificate Wallet" },
  "wq.tab.profile": { ar: "ملف المزرعة", en: "Farm Profile" },
  "wq.seasons": { ar: "المواسم", en: "Seasons" },
  "wq.season": { ar: "موسم", en: "Season" },
  "wq.latestCert": { ar: "أحدث شهادة", en: "Latest certificate" },
  "wq.ctaSub": { ar: "أربع خطوات موجّهة: الصنف، الكمية، الموقع، المراجعة — ثم تصدر شهادتك فوراً.", en: "Four guided steps — variety, quantity, location, review — then your certificate is issued instantly." },
  "wq.startWizard": { ar: "ابدأ التوثيق", en: "Start certifying" },
  "wq.memberSince": { ar: "عضو منذ", en: "Member since" },
  "wq.method": { ar: "طريقة الدخول", en: "Sign-in method" },
  "wq.password": { ar: "بريد وكلمة مرور", en: "Email & password" },
  "wq.edit": { ar: "تعديل", en: "Edit" },
  "wz.step.variety": { ar: "الصنف", en: "Variety" },
  "wz.step.quantity": { ar: "الكمية والتاريخ", en: "Quantity & date" },
  "wz.step.location": { ar: "موقع المزرعة", en: "Farm location" },
  "wz.step.review": { ar: "المراجعة", en: "Review" },
  "wz.region": { ar: "المنطقة المكتشفة", en: "Detected region" },
  "wz.back": { ar: "رجوع", en: "Back" },
  "wz.next": { ar: "التالي", en: "Next" },
  "wz.another": { ar: "توثيق محصول آخر", en: "Certify another yield" },
  "wz.successTitle": { ar: "تم إصدار شهادة وثيق", en: "Your Watheeq certificate is issued" },
  "wz.successSub": { ar: "شهادتك موثّقة جغرافياً وقابلة للتحقق عبر رمز QR.", en: "Geo-verified and QR-verifiable — share it with buyers." },
  "wz.err.variety": { ar: "اختر صنف التمر", en: "Choose a date variety" },
  "wz.err.quantity": { ar: "أدخل كمية صحيحة وتاريخ حصاد غير مستقبلي", en: "Enter a valid quantity and a non-future harvest date" },
  "wz.err.location": { ar: "حدّد موقعاً داخل المملكة", en: "Pick a location inside the Kingdom" },
  "wallet.view": { ar: "عرض", en: "View" },
  "wallet.copyLink": { ar: "نسخ رابط التحقق", en: "Copy verify link" },
  "wallet.copied": { ar: "تم نسخ رابط التحقق", en: "Verify link copied" },
  "wallet.shareText": { ar: "شهادة محصول تمور موثّقة من وثيق — واحة التمور", en: "Verified date provenance certificate by Watheeq — Dates Oasis" },
  "knowledge.search": { ar: "اسأل", en: "Ask" },
  "knowledge.searching_short": { ar: "جارٍ البحث…", en: "Searching…" },
  "knowledge.filterBy": { ar: "حصر البحث في", en: "Search within" },
  "knowledge.history": { ar: "آخر أسئلتك", en: "Recent questions" },
  "knowledge.answer": { ar: "الإجابة", en: "Answer" },
  "knowledge.partial": { ar: "معرفة جزئية", en: "Partial knowledge" },
  "knowledge.noMatch": { ar: "لا نتائج كافية", en: "No strong match" },
  "knowledge.copy": { ar: "نسخ الإجابة", en: "Copy answer" },
  "knowledge.references": { ar: "المراجع", en: "References" },
  "knowledge.open": { ar: "افتح الصفحة", en: "Open page" },
  "knowledge.cat.general": { ar: "عام", en: "General" },
  "prov.tag": { ar: "وثيق — توثيق محصول التمور", en: "Watheeq — Origin Trust" },
  "prov.title": { ar: "وثيق | Watheeq — وثّق محصول تمورك", en: "Watheeq | وثيق — Certify Your Dates' Origin" },
  "prov.steps.title": { ar: "كيف يعمل وثيق", en: "How Watheeq works" },
  "prov.s1.title": { ar: "سجّل", en: "Register" },
  "prov.s1.desc": { ar: "أنشئ حساب مزرعتك بالبريد أو Google وأكمل ملف المزرعة والمنطقة.", en: "Create your farm account with email or Google and complete your farm profile." },
  "prov.s2.title": { ar: "وثّق", en: "Certify" },
  "prov.s2.desc": { ar: "اتبع المعالج الموجّه: الصنف، الكمية، موقع المزرعة على الخريطة — وتصدر شهادة وثيق فوراً برمز QR.", en: "Follow the guided wizard — variety, quantity, farm location on the map — and your Watheeq certificate is issued instantly with a QR code." },
  "prov.s3.title": { ar: "شارك", en: "Share" },
  "prov.s3.desc": { ar: "حمّل الشهادة PDF أو شارك رابط التحقق مع المشترين عبر واتساب وX.", en: "Download the PDF or share the verify link with buyers via WhatsApp and X." },
  "prov.trust1": { ar: "موثّق جغرافياً", en: "Geo-verified" },
  "prov.trust2": { ar: "تحقق برمز QR", en: "QR-verified" },
  "prov.trust3": { ar: "مناطق التراث", en: "Heritage regions" },
  "prov.trust4": { ar: "بدون بيانات اتصال عامة", en: "No public contact data" },
  "prov.quote": { ar: "«شهادة واحدة، رمز QR واحد — والمشتري يعرف مزرعتي وصنفي ومنطقتي في ثانية.»", en: "“One certificate, one QR code — and the buyer knows my farm, my variety and my region in a second.”" },
  "prov.quoteBy": { ar: "مزارع خلاص، الأحساء — شهادة وثيق التجريبية DO-2026-SEED01", en: "Khalas farmer, Al-Ahsa — Watheeq demo certificate DO-2026-SEED01" },
  "auth.or": { ar: "أو", en: "or" },
  "auth.google": { ar: "المتابعة بحساب Google", en: "Continue with Google" },
  "auth.google_wait": { ar: "جارٍ إتمام تسجيل الدخول…", en: "Completing sign-in…" },
  "auth.google_failed": { ar: "تعذّر إتمام تسجيل الدخول بحساب Google", en: "Google sign-in could not be completed" },
  "auth.google_ok": { ar: "تم تسجيل الدخول بنجاح", en: "Signed in successfully" },
  "auth.complete_title": { ar: "أكمل ملف مزرعتك", en: "Complete your farm profile" },
  "auth.complete_sub": { ar: "خطوة واحدة قبل الوصول إلى لوحة المحصول: اسم المزرعة والمنطقة.", en: "One step before your Provenance dashboard: farm name and region." },
  "auth.complete_save": { ar: "حفظ والمتابعة", en: "Save and continue" },
  "auth.complete_done": { ar: "تم حفظ ملف المزرعة", en: "Farm profile saved" },
  "err.GOOGLE_SESSION_INVALID": { ar: "جلسة Google غير صالحة أو منتهية", en: "Google session is invalid or expired" },
  "err.ADMIN_ONLY": { ar: "هذا الحساب ليس حساب مشرف", en: "This account is not an admin account" },
  "a7.nav.inbox": { ar: "صندوق الوارد", en: "Inbox" },
  "a7.nav.messages": { ar: "الرسائل", en: "Messages" },
  "inbox.unread": { ar: "غير مقروءة", en: "Unread" },
  "inbox.read": { ar: "مقروءة", en: "Read" },
  "inbox.markUnread": { ar: "تعليم كغير مقروءة", en: "Mark unread" },
  "contact.tag": { ar: "تواصل", en: "Contact" },
  "contact.title": { ar: "تواصل معنا", en: "Contact Us" },
  "contact.sub": { ar: "للاستفسارات العامة وشراكات B2B وطلبات حماية البيانات والملكية الفكرية.", en: "General enquiries, B2B partnerships, data-protection and IP requests." },
  "contact.infoTitle": { ar: "معلومات التواصل", en: "Contact details" },
  "contact.address": { ar: "المملكة العربية السعودية", en: "Kingdom of Saudi Arabia" },
  "contact.privacyNote": { ar: "تُعالج رسالتك وفق سياسة الخصوصية (PDPL) ولا يُنشر بريدك.", en: "Your message is handled under our PDPL-aligned Privacy Policy; your email is never published." },
  "contact.name": { ar: "الاسم", en: "Name" },
  "contact.category": { ar: "الموضوع", en: "Subject" },
  "contact.message": { ar: "الرسالة", en: "Message" },
  "contact.send": { ar: "إرسال", en: "Send" },
  "contact.sent": { ar: "تم إرسال رسالتك", en: "Your message has been sent" },
  "contact.sentTitle": { ar: "شكراً لتواصلك", en: "Thank you" },
  "contact.sentDesc": { ar: "سنرد على بريدك خلال أيام العمل القادمة.", en: "We will reply to your email within the next business days." },
  "contact.cat.general": { ar: "استفسار عام", en: "General" },
  "contact.cat.b2b": { ar: "شراكة B2B", en: "B2B partnership" },
  "contact.cat.privacy": { ar: "خصوصية البيانات", en: "Data privacy" },
  "contact.cat.ip": { ar: "الملكية الفكرية", en: "Intellectual property" },
  "contact.err.name": { ar: "الاسم مطلوب (حرفان على الأقل)", en: "Name is required (2+ characters)" },
  "contact.err.email": { ar: "بريد إلكتروني غير صالح", en: "Invalid email address" },
  "contact.err.message": { ar: "الرسالة قصيرة جداً (10 أحرف على الأقل)", en: "Message too short (10+ characters)" },
  "legal.tag": { ar: "قانوني", en: "Legal" },
  "legal.updated": { ar: "آخر تحديث", en: "Last updated" },
  "legal.terms.title": { ar: "شروط الاستخدام", en: "Terms of Service" },
  "legal.privacy.title": { ar: "سياسة الخصوصية", en: "Privacy Policy" },
  "legal.dmca.title": { ar: "حقوق الملكية الفكرية", en: "Copyright & IP" },
  "settings.acts": { ar: "فصول الجولة", en: "Tour acts" },
  "tour.act.intro": { ar: "الافتتاحية", en: "Opening" },
  "tour.act.map": { ar: "الخريطة والطرق", en: "Map & Routes" },
  "tour.act.search": { ar: "البحث الدلالي", en: "Semantic Search" },
  "tour.act.varieties": { ar: "أصناف التمور", en: "Varieties" },
  "tour.act.culinary": { ar: "التراث الطهوي", en: "Culinary" },
  "tour.act.provenance": { ar: "وثيق — شهادات المحصول", en: "Watheeq — Provenance" },
  "tour.act.stories": { ar: "الحكايات", en: "Stories" },
  "tour.act.outro": { ar: "الختام", en: "Closing" },
  "tour.introSub": { ar: "رحلة سينمائية عبر تراث التمور السعودية: الواحات، الأصناف، المطبخ، والمحصول الموثّق.", en: "A cinematic journey through Saudi date heritage: oases, varieties, cuisine and verified provenance." },
  "tour.culinaryFrom": { ar: "من التقليدي", en: "From tradition" },
  "tour.culinaryTo": { ar: "إلى المعاصر", en: "to modern" },
  "tour.certCaption": { ar: "وثيق: كل شهادة محصول تحمل رمز QR عاماً يعرض اسم المزارع والصنف والحالة — صالحة أو ملغاة — دون أي بيانات اتصال. الثقة قابلة للتحقق في ثانية.", en: "Watheeq: every provenance certificate carries a public QR code revealing the farmer, variety and status — valid or revoked — with no contact data. Trust, verifiable in a second." },
  "tour.status.valid": { ar: "صالحة", en: "VALID" },
  "tour.status.revoked": { ar: "ملغاة", en: "REVOKED" },
  "nav.culinary": { ar: "التراث الطهوي", en: "Culinary" },
  "a7.nav.culinary": { ar: "أطباق التمر", en: "Culinary Dishes" },
  "a7.nav.oases": { ar: "الواحات والمدن", en: "Oases & Cities" },
  "collection.oases.sub": { ar: "الواحات والمدن التي نمت حولها الحضارة والنخيل منذ آلاف السنين — من الأحساء إلى العلا وبيشة.", en: "The oases and cities around which palms and civilization have grown for millennia — from Al-Ahsa to AlUla and Bisha." },
  "culinary.all": { ar: "كل الأطباق", en: "All dishes" },
  "culinary.ingredients": { ar: "المكوّنات", en: "Ingredients" },
  "culinary.relatedVarieties": { ar: "أصناف التمر المستخدمة", en: "Date varieties used" },
  "culinary.newDish": { ar: "طبق جديد", en: "New dish" },
  "culinary.dishName": { ar: "اسم الطبق", en: "Dish name" },
  "culinary.tagline": { ar: "الشعار القصير", en: "Tagline" },
  "culinary.regionKey": { ar: "مفتاح المنطقة", en: "Region key" },
  "culinary.order": { ar: "الترتيب", en: "Order" },
  "culinary.description": { ar: "الوصف المختصر", en: "Short description" },
  "culinary.modernName": { ar: "اسم النسخة المعاصرة", en: "Modern version name" },
  "culinary.imageTraditional": { ar: "صورة الطبق التقليدي", en: "Traditional image" },
  "culinary.imageModern": { ar: "صورة النسخة المعاصرة", en: "Modern image" },
  "culinary.addIngredient": { ar: "إضافة مكوّن", en: "Add ingredient" },
  "stories.latest": { ar: "الأحدث", en: "Latest" },
  "stories.byCategory": { ar: "حسب التصنيف", en: "By category" },
  "nav.gallery": { ar: "المعرض البصري", en: "Gallery" },
  "a7.nav.media": { ar: "مكتبة الوسائط", en: "Media Library" },
  "media.uploadNew": { ar: "رفع صورة جديدة", en: "Upload a new image" },
  "media.tabUpload": { ar: "رفع", en: "Upload" },
  "media.tabLibrary": { ar: "المكتبة", en: "Library" },
  "media.tabUrl": { ar: "رابط", en: "URL" },
  "media.dropHere": { ar: "اسحب صورة هنا أو انقر للاختيار", en: "Drop an image here or click to browse" },
  "media.dropHint": { ar: "JPEG / PNG / WebP — حتى 8 ميغابايت. تُحوَّل تلقائياً إلى WebP وتُزال بيانات EXIF.", en: "JPEG / PNG / WebP — up to 8 MB. Converted to WebP, EXIF stripped." },
  "media.badType": { ar: "نوع الملف غير مدعوم", en: "Unsupported file type" },
  "media.tooLarge": { ar: "الملف أكبر من 8 ميغابايت", en: "File is larger than 8 MB" },
  "media.uploaded": { ar: "تم رفع الصورة", en: "Image uploaded" },
  "media.uploadFailed": { ar: "فشل الرفع", en: "Upload failed" },
  "media.picked": { ar: "تم اختيار الصورة", en: "Image selected" },
  "media.empty": { ar: "لا توجد صور مرفوعة بعد", en: "No uploaded images yet" },
  "media.copied": { ar: "تم نسخ الرابط", en: "URL copied" },
  "media.copy": { ar: "نسخ الرابط", en: "Copy URL" },
  "media.deleted": { ar: "تم حذف الصورة", en: "Image deleted" },
  "media.deleteTitle": { ar: "حذف الصورة؟", en: "Delete image?" },
  "media.usedIn": { ar: "مستخدمة في", en: "Used in" },
  "media.unused": { ar: "غير مستخدمة", en: "Not referenced" },
  "media.usedWarn": { ar: "تحذير: هذه الصورة مستخدمة في:", en: "Warning: this image is referenced by:" },
  "settings.presentation": { ar: "وضع العرض التقديمي", en: "Presentation Mode" },
  "settings.presentationLabel": { ar: "تفعيل وضع العرض التقديمي", en: "Enable Presentation Mode" },
  "settings.presentationHint": { ar: "يُظهر زر «العرض التقديمي» في الصفحة الرئيسية وخريطة التراث ويشغّل جولة سينمائية بطول ~90 ثانية.", en: "Shows the Presentation button on the homepage and Heritage Map and runs a ~90s cinematic tour." },
  "settings.stopSeconds": { ar: "مدة كل محطة (ثانية)", en: "Seconds per stop" },
  "settings.loop": { ar: "تكرار الجولة تلقائياً", en: "Autoplay loop" },
  "settings.searchQuery": { ar: "سؤال البحث الحي في الجولة", en: "Live search question used in the tour" },
  "settings.estimated": { ar: "المدة التقديرية للجولة", en: "Estimated tour length" },
  "settings.preview": { ar: "معاينة الجولة", en: "Preview tour" },
  "settings.saved": { ar: "تم حفظ الإعدادات", en: "Settings saved" },
  "tour.button": { ar: "العرض التقديمي", en: "Presentation" },
  "tour.act1": { ar: "الواحات والمواقع", en: "Oases & Sites" },
  "tour.act2": { ar: "طرق التجارة", en: "Trade Routes" },
  "tour.act3": { ar: "بحث دلالي حي", en: "Live Semantic Search" },
  "tour.pause": { ar: "إيقاف مؤقت", en: "Pause" },
  "tour.resume": { ar: "متابعة", en: "Resume" },
  "tour.skip": { ar: "التالي", en: "Skip" },
  "tour.exit": { ar: "خروج", en: "Exit" },
  "gallery.tag": { ar: "المعرض", en: "Gallery" },
  "gallery.title": { ar: "معرض التراث البصري", en: "Visual Heritage Gallery" },
  "gallery.sub": { ar: "صور أصناف التمور والواحات والمطبخ والحكايات في مكان واحد.", en: "Imagery of date varieties, oases, cuisine and stories — in one place." },
  "gallery.kind.all": { ar: "الكل", en: "All" },
  "gallery.kind.variety": { ar: "أصناف", en: "Varieties" },
  "gallery.kind.oasis": { ar: "واحات", en: "Oases" },
  "gallery.kind.route": { ar: "طرق", en: "Routes" },
  "gallery.kind.culinary": { ar: "مطبخ", en: "Cuisine" },
  "gallery.kind.story": { ar: "حكايات", en: "Stories" },
  "gallery.kind.heritage": { ar: "تراث", en: "Heritage" },
  "gallery.kind.media": { ar: "وسائط", en: "Media" },
  "filters.label": { ar: "تصفية", en: "Filter" },
  "filters.region": { ar: "المنطقة", en: "Region" },
  "filters.sweetness": { ar: "الحلاوة", en: "Sweetness" },
  "filters.texture": { ar: "القوام", en: "Texture" },
  "filters.none": { ar: "لا نتائج مطابقة", en: "No matching results" },
  "stories.search": { ar: "ابحث في الحكايات…", en: "Search stories…" },
  "varieties.all": { ar: "استعرض الأصناف الـ 16 المميزة", en: "View all 16 featured varieties" },
  "detail.prev": { ar: "السابق", en: "Previous" },
  "detail.next": { ar: "التالي", en: "Next" },
  "detail.sameRegion": { ar: "أصناف من نفس المنطقة", en: "Varieties from the same region" },
  "detail.askKnowledge": { ar: "اسأل الموسوعة عن", en: "Ask the encyclopedia about" },
  "detail.oasisLink": { ar: "واحة المنشأ", en: "Origin oasis" },
  "a7.nav.dashboard": { ar: "لوحة التحكم", en: "Dashboard" },
  "a7.nav.content": { ar: "المحتوى", en: "Content" },
  "a7.nav.stories": { ar: "الحكايات والمقالات", en: "Stories / Articles" },
  "a7.nav.varieties": { ar: "أصناف التمور", en: "Varieties" },
  "a7.nav.routes": { ar: "طرق التجارة", en: "Trade Routes" },
  "a7.nav.knowledge": { ar: "وثائق المعرفة", en: "Knowledge Docs" },
  "a7.nav.mapdata": { ar: "بيانات الخريطة", en: "Map Data" },
  "a7.nav.locations": { ar: "المواقع", en: "Locations" },
  "a7.nav.maproutes": { ar: "مسارات الخريطة", en: "Route Waypoints" },
  "a7.nav.provenance": { ar: "وثيق (المحصول)", en: "Watheeq (Provenance)" },
  "a7.nav.farmers": { ar: "المزارعون", en: "Farmers" },
  "a7.nav.yields": { ar: "المحاصيل", en: "Yields" },
  "a7.nav.certificates": { ar: "الشهادات", en: "Certificates" },
  "a7.nav.settings": { ar: "الإعدادات", en: "Settings" },
  "a7.settings.soon": { ar: "إعدادات المنصة ستتوفر في مرحلة لاحقة.", en: "Platform settings will arrive in a later phase." },
  "a7.search": { ar: "ابحث…", en: "Search…" },
  "a7.status": { ar: "الحالة", en: "Status" },
  "a7.all": { ar: "الكل", en: "All" },
  "a7.draft": { ar: "مسودة", en: "Draft" },
  "a7.published": { ar: "منشور", en: "Published" },
  "a7.updated": { ar: "آخر تحديث", en: "Updated" },
  "a7.created": { ar: "أُنشئ", en: "Created" },
  "a7.actions": { ar: "إجراءات", en: "Actions" },
  "a7.page": { ar: "صفحة", en: "Page" },
  "a7.of": { ar: "من", en: "of" },
  "a7.empty": { ar: "لا توجد عناصر", en: "No items yet" },
  "a7.title": { ar: "العنوان", en: "Title" },
  "a7.slug": { ar: "المعرّف (Slug)", en: "Slug" },
  "a7.slugTaken": { ar: "هذا المعرّف مستخدم بالفعل", en: "This slug is already taken" },
  "a7.slugInvalid": { ar: "أحرف لاتينية صغيرة وأرقام وشرطات فقط", en: "Lowercase letters, numbers and dashes only" },
  "a7.cover": { ar: "رابط صورة الغلاف", en: "Cover image URL" },
  "a7.excerpt": { ar: "المقتطف", en: "Excerpt" },
  "a7.publishDate": { ar: "تاريخ النشر", en: "Publish date" },
  "a7.readMin": { ar: "دقائق القراءة", en: "Read minutes" },
  "a7.category": { ar: "التصنيف", en: "Category" },
  "a7.tags": { ar: "الوسوم", en: "Tags" },
  "a7.tagsHint": { ar: "مفصولة بفواصل", en: "Comma separated" },
  "a7.author": { ar: "الكاتب", en: "Author" },
  "a7.body": { ar: "متن المقال", en: "Article body" },
  "a7.addBlock": { ar: "إضافة فقرة", en: "Add block" },
  "a7.heading": { ar: "العنوان الفرعي", en: "Heading" },
  "a7.text": { ar: "النص", en: "Text" },
  "a7.facts": { ar: "الحقائق", en: "Facts" },
  "a7.addFact": { ar: "إضافة حقيقة", en: "Add fact" },
  "a7.sections": { ar: "الأقسام", en: "Sections" },
  "a7.addSection": { ar: "إضافة قسم", en: "Add section" },
  "a7.label": { ar: "التسمية", en: "Label" },
  "a7.value": { ar: "القيمة", en: "Value" },
  "a7.subtitle": { ar: "العنوان الثانوي", en: "Subtitle" },
  "a7.summary": { ar: "الملخص (وصف SEO)", en: "Summary (SEO description)" },
  "a7.hero": { ar: "رابط صورة الغلاف", en: "Hero image URL" },
  "a7.mapFocus": { ar: "تركيز الخريطة", en: "Map focus" },
  "a7.related": { ar: "روابط ذات صلة", en: "Related links" },
  "a7.relatedHint": { ar: "معرّفات مفصولة بفواصل", en: "slugs, comma separated" },
  "a7.publish": { ar: "نشر", en: "Publish" },
  "a7.unpublish": { ar: "إلغاء النشر", en: "Unpublish" },
  "a7.publishedToast": { ar: "تم النشر — المقال ظاهر للعامة", en: "Published — the story is now public" },
  "a7.unpublished": { ar: "أُلغي النشر — المقال مسودة الآن", en: "Unpublished — the story is now a draft" },
  "a7.deleteTitle": { ar: "حذف نهائي؟", en: "Delete permanently?" },
  "a7.deleteDesc": { ar: "سيتم حذف", en: "You are about to delete" },
  "a7.deleteCons1": { ar: "لا يمكن التراجع عن هذا الإجراء", en: "This action cannot be undone" },
  "a7.deleteCons2": { ar: "ستختفي الصفحة العامة من خريطة الموقع", en: "The public page disappears from the sitemap" },
  "a7.deleteCons3": { ar: "الروابط المؤدية إليها من الصفحات الأخرى ستنقطع", en: "Related links from other pages will break" },
  "a7.deleteCons4": { ar: "سيُزال من فهرس البحث الدلالي", en: "It is removed from the semantic search index" },
  "a7.deleteCons5": { ar: "سيُزال من الخريطة ثلاثية الأبعاد", en: "It is removed from the 3D map" },
  "a7.confirm": { ar: "تأكيد", en: "Confirm" },
  "a7.typeToConfirm": { ar: "اكتب للتأكيد:", en: "Type to confirm:" },
  "a7.unsaved": { ar: "تغييرات غير محفوظة", en: "Unsaved changes" },
  "a7.unsavedTitle": { ar: "تغييرات غير محفوظة", en: "Unsaved changes" },
  "a7.unsavedDesc": { ar: "لديك تعديلات لم تُحفظ. هل تريد المغادرة وفقدانها؟", en: "You have edits that are not saved. Leave and discard them?" },
  "a7.unsavedLeave": { ar: "مغادرة بدون حفظ", en: "Leave without saving" },
  "a7.unsavedStay": { ar: "البقاء", en: "Stay" },
  "a7.required": { ar: "هذا الحقل مطلوب بالعربية والإنجليزية", en: "Required in both Arabic and English" },
  "a7.fixErrors": { ar: "يرجى تصحيح الحقول المطلوبة", en: "Please fix the highlighted fields" },
  "a7.deactivateTitle": { ar: "تعطيل حساب المزارع", en: "Deactivate farmer account" },
  "a7.deactivateDesc": { ar: "سيُمنع هذا المزارع من الدخول", en: "This farmer will be locked out" },
  "a7.deactivateCons1": { ar: "لن يستطيع تسجيل الدخول أو إنشاء محاصيل جديدة", en: "Cannot sign in or submit new yields" },
  "a7.deactivateCons2": { ar: "شهاداته الحالية تبقى صالحة للتحقق", en: "Existing certificates remain verifiable" },
  "a7.deactivateCheck": { ar: "أفهم العواقب وأرغب في التعطيل", en: "I understand the consequences and want to deactivate" },
  "a7.reactivateTitle": { ar: "إعادة تفعيل الحساب", en: "Reactivate account" },
  "a7.reactivateDesc": { ar: "سيتمكن المزارع من الدخول مجدداً", en: "The farmer will be able to sign in again" },
  "a7.deactivated": { ar: "تم تعطيل الحساب", en: "Account deactivated" },
  "a7.reactivated": { ar: "تم إعادة تفعيل الحساب", en: "Account reactivated" },
  "a7.revokeTitle": { ar: "إلغاء الشهادة", en: "Revoke certificate" },
  "a7.revokeDesc": { ar: "إلغاء شهادة المحصول", en: "Revoke the provenance certificate" },
  "a7.revokeCons1": { ar: "ستظهر الشهادة «ملغاة» في صفحة التحقق العامة", en: "The public verify page will show REVOKED" },
  "a7.revokeCons2": { ar: "رمز QR المطبوع سيقود إلى حالة الإلغاء", en: "The printed QR code will resolve to the revoked status" },
  "a7.revokeCons3": { ar: "يمكن إعادة الاعتماد لاحقاً من هذه اللوحة", en: "It can be reinstated later from this panel" },
  "a7.revoked": { ar: "تم إلغاء الشهادة", en: "Certificate revoked" },
  "a7.reinstateTitle": { ar: "إعادة اعتماد الشهادة", en: "Reinstate certificate" },
  "a7.reinstateDesc": { ar: "ستعود الشهادة صالحة", en: "The certificate becomes valid again" },
  "a7.reinstated": { ar: "تمت إعادة الاعتماد", en: "Certificate reinstated" },
  "a7.downloaded": { ar: "تم تنزيل الشهادة", en: "Certificate downloaded" },
  "a7.savedEmbedded": { ar: "تم الحفظ وإعادة الفهرسة الدلالية", en: "Saved and re-embedded for search" },
  "a7.embedNote": { ar: "يُعاد حساب التضمين الدلالي تلقائياً عند الحفظ.", en: "Semantic embeddings are recomputed automatically on save." },
  "a7.newStory": { ar: "حكاية جديدة", en: "New story" },
  "a7.reviewYields": { ar: "مراجعة المحاصيل", en: "Review yields" },
  "a7.activity": { ar: "النشاط الأخير", en: "Recent activity" },
  "a7.certsWidget": { ar: "حالة الشهادات", en: "Certificate status" },
  "a7.trendSub": { ar: "الاتجاهات محسوبة من آخر 8 أسابيع", en: "Trends from the last 8 weeks" },
  "a7.yieldCreated": { ar: "محصول جديد", en: "New yield" },
  "a7.farmerJoined": { ar: "مزارع جديد", en: "Farmer joined" },
  "dash.status.revoked": { ar: "ملغاة", en: "Revoked" },
  "dash.emptyTitle": { ar: "لا محاصيل بعد", en: "No yields yet" },
  "dash.emptyCta": { ar: "سجّل أول محصول", en: "Register your first yield" },
  "dash.downloaded": { ar: "تم تنزيل الشهادة", en: "Certificate downloaded" },
  "dash.submitted": { ar: "تم تسجيل المحصول وإصدار الشهادة", en: "Yield registered and certificate issued" },
  "nav.explore": { ar: "استكشف", en: "Explore" },
  "nav.stories": { ar: "حكايات التراث", en: "Heritage Stories" },
  "nav.exploreStoriesSub": { ar: "مقالات معمّقة عن ثقافة التمور", en: "In-depth stories on date culture" },
  "footer.platform": { ar: "المنصة", en: "Platform" },
  "content.readMore": { ar: "اكتشف المزيد", en: "Discover more" },
  "content.viewOnMap": { ar: "شاهد على الخريطة", en: "View on map" },
  "content.related": { ar: "استكشف أيضاً", en: "Explore further" },
  "content.backTo": { ar: "العودة إلى", en: "Back to" },
  "collection.varieties.sub": { ar: "ستة عشر صنفاً مميزاً صاغت ذائقة المملكة — من العجوة إلى بياض نجران. صفِّ حسب المنطقة أو الحلاوة أو القوام، أو استكشف الدليل الكامل لـ 76 صنفاً.", en: "Sixteen featured varieties that shaped the Kingdom's palate — from Ajwa to Najran's Bayadh. Filter by region, sweetness or texture, or explore the full 76-cultivar directory." },
  "collection.routes.sub": { ar: "الطرق التي حملت التمور والبخور والحجيج عبر الجزيرة العربية.", en: "The roads that carried dates, incense and pilgrims across Arabia." },
  "stories.tag": { ar: "حكايات", en: "Stories" },
  "stories.title": { ar: "حكايات التراث", en: "Heritage Stories" },
  "stories.sub": { ar: "مقالات معمّقة عن ثقافة التمور السعودية وتاريخها ومطبخها.", en: "In-depth stories on Saudi date culture, history and cuisine." },
  "stories.all": { ar: "كل الحكايات", en: "All stories" },
  "stories.min": { ar: "دقائق قراءة", en: "min read" },
  "brand.ar": { ar: "واحة التمور", en: "واحة التمور" },
  "brand.en": { ar: "Dates Oasis", en: "Dates Oasis" },

  // Hero
  "hero.eyebrow": { ar: "منصة التراث السعودي الفاخرة", en: "The Luxury Saudi Heritage Platform" },
  "hero.title": { ar: "واحة التمور — إرث النخيل السعودي", en: "Dates Oasis — The Saudi Palm Legacy" },
  "hero.subtitle": {
    ar: "خريطة ثلاثية الأبعاد، موسوعة أصناف، سوق مزادات حيّ، وشهادات محصول موثّقة برمز QR — إرث النخيل السعودي في منصة واحدة",
    en: "A 3D heritage map, a cultivar encyclopedia, a live auction souq and QR-verified provenance — the Saudi palm legacy on one platform",
  },
  "hero.cta_souq": { ar: "ادخل السوق", en: "Enter the Souq" },
  "hero.cta_watheeq": { ar: "وثيق — توثيق المحصول", en: "Watheeq Provenance" },
  "tab.dashboard": { ar: "حسابي", en: "Account" },
  "home.lead.souq.k": { ar: "السوق", en: "The Souq" },
  "home.lead.souq.t": { ar: "من النخلة إلى المزاد — مباشرة", en: "From the palm to the auction — live" },
  "home.lead.souq.d": { ar: "مزادات حيّة لمحاصيل التمور من مزارعين وتجّار موثّقين. كل عرض بعدّاد زمني، وسعر يتحدّث لحظياً، وشهادة وثيق حين تتوفر.", en: "Live auctions for date harvests from verified farmers and traders — every lot with a countdown, a live price and, where available, a Watheeq certificate." },
  "home.souq.cta": { ar: "ادخل السوق", en: "Enter the Souq" },
  "home.lead.wq.k": { ar: "وثيق", en: "Watheeq" },
  "home.lead.wq.t": { ar: "الثقة تبدأ من المصدر", en: "Trust begins at the origin" },
  "home.lead.wq.d": { ar: "شهادة رقمية لكل محصول: المزرعة، الصنف، المنطقة والكمية — مختومة برمز QR يتحقق منه أي مشترٍ في ثوانٍ.", en: "A digital certificate for every harvest — farm, variety, region and quantity — sealed with a QR code any buyer can verify in seconds." },
  "home.wq.s1": { ar: "يُسجّل المزارع محصوله", en: "The farmer records a harvest" },
  "home.wq.s1d": { ar: "المزرعة، الصنف، الكمية والموقع من لوحة وثيق", en: "Farm, variety, quantity and location from the Watheeq dashboard" },
  "home.wq.s2": { ar: "تُصدر شهادة برمز QR", en: "A QR-sealed certificate is issued" },
  "home.wq.s2d": { ar: "ملف PDF قابل للطباعة ورابط تحقق عام", en: "A printable PDF and a public verification link" },
  "home.wq.s3": { ar: "يتحقق المشتري في ثوانٍ", en: "Buyers verify in seconds" },
  "home.wq.s3d": { ar: "امسح الرمز أو افتح الرابط — الحالة والتفاصيل مباشرة", en: "Scan the code or open the link — status and details, live" },
  "home.wq.certs": { ar: "شهادة صالحة", en: "valid certificates" },
  "home.wq.farms": { ar: "مزرعة مسجّلة", en: "registered farms" },
  "home.wq.farmers": { ar: "مزارع", en: "farmers" },
  "home.wq.verifyCta": { ar: "تحقق من شهادة", en: "Verify a certificate" },
  "home.wq.joinCta": { ar: "انضم كمزارع", en: "Join as a farmer" },
  "home.lead.pillars.k": { ar: "استكشف", en: "Explore" },
  "home.lead.pillars.t": { ar: "أربع بوابات إلى الإرث", en: "Four gateways into the heritage" },
  "home.lead.pillars.d": { ar: "خريطة تفاعلية، بحث معرفي ذكي، موسوعة أصناف، وبوابات المناطق — كلها متشابكة بروابط حيّة مع السوق ووثيق.", en: "An interactive map, AI heritage search, a cultivar encyclopedia and region gateways — all cross-linked with the Souq and Watheeq." },
  "home.pillar.map": { ar: "الخريطة ثلاثية الأبعاد", en: "3D Heritage Map" },
  "home.pillar.map.d": { ar: "واحات وطرق تجارة تاريخية بتحليق سينمائي", en: "Oases and historic trade routes in cinematic flight" },
  "home.pillar.knowledge": { ar: "بحث المعرفة", en: "Knowledge Search" },
  "home.pillar.knowledge.d": { ar: "اسأل بالعربية أو الإنجليزية واحصل على إجابات بمصادرها", en: "Ask in Arabic or English and get sourced answers" },
  "home.pillar.varieties": { ar: "موسوعة الأصناف", en: "Cultivar Encyclopedia" },
  "home.pillar.varieties.d": { ar: "76 صنفاً سعودياً بالصورة والقوام والموسم", en: "76 Saudi cultivars with imagery, texture and season" },
  "home.pillar.regions": { ar: "بوابات المناطق", en: "Region Gateways" },
  "home.pillar.regions.d": { ar: "من الأحساء إلى الجوف — إرث وأصناف ومزادات", en: "From Al-Ahsa to Al-Jouf — heritage, cultivars and auctions" },
  "home.pillar.go": { ar: "استكشف", en: "Explore" },
  "home.close.k": { ar: "انضم إلينا", en: "Join us" },
  "home.close.t": { ar: "مكانك في واحة التمور", en: "Your place in the Oasis" },
  "home.close.d": { ar: "حساب واحد لكل الأدوار: وثّق محصولك كمزارع، اعرض تمورك كتاجر، أو زايد كمشترٍ.", en: "One account for every role: certify harvests as a farmer, list dates as a trader, or bid as a buyer." },
  "home.close.farmer": { ar: "مزارع", en: "Farmer" },
  "home.close.trader": { ar: "تاجر", en: "Trader" },
  "home.close.buyer": { ar: "مشترٍ", en: "Buyer" },
  "tour.act.souq": { ar: "السوق الحيّ", en: "Live Souq" },
  "tour.act.regions": { ar: "بوابات المناطق", en: "Region Gateways" },
  "tour.act.hub": { ar: "حساب واحد — كل الأدوار", en: "One account — every role" },
  "tour.souqCaption": { ar: "مزادات حيّة بعدّاد زمني وسعر لحظي — من مزارعين وتجّار موثّقين", en: "Live auctions with countdowns and real-time prices — from verified farmers and traders" },
  "tour.hubCaption": { ar: "لوحة واحدة تجمع المزارع والتاجر والمشتري: مقاييس حيّة وتنبيهات وروابط مباشرة", en: "One hub for farmer, trader and buyer: live metrics, alerts and direct shortcuts" },
  "hero.cta_map": { ar: "استكشف الخريطة", en: "Explore the Map" },
  "hero.cta_varieties": { ar: "موسوعة التمور", en: "Date Encyclopedia" },
  "hero.scroll": { ar: "مرّر للاستكشاف", en: "Scroll to explore" },

  // Varieties
  "varieties.tag": { ar: "موسوعة الأصناف", en: "The Encyclopedia" },
  "varieties.title": { ar: "أصناف التمور الملكية", en: "Royal Date Varieties" },
  "varieties.sub": {
    ar: "ثمانية أصناف من نخيل المملكة — من العجوة إلى العنبرة — لكل منها حكاية أرض وطعم لا يُنسى",
    en: "Eight varieties from the Kingdom's palms — from Ajwa to Anbara — each with a story of land and an unforgettable taste",
  },
  "varieties.region": { ar: "المنطقة", en: "Region" },

  // Culinary
  "culinary.tag": { ar: "التراث الطهوي", en: "Culinary Heritage" },
  "culinary.title": { ar: "من الموقد القديم إلى الطبق المعاصر", en: "From Ancient Hearth to Modern Plate" },
  "culinary.sub": {
    ar: "أطباق التمر النجدية العريقة تُعاد صياغتها برؤية فاخرة معاصرة",
    en: "Time-honored Najdi date dishes reimagined with contemporary luxury",
  },
  "culinary.traditional": { ar: "الأصل التراثي", en: "The Tradition" },
  "culinary.modern": { ar: "الرؤية المعاصرة", en: "The Reimagining" },

  // Stats
  "stats.title": { ar: "أرقام من قلب الواحة", en: "Numbers from the Oasis" },
  "stats.palms": { ar: "نخلة في واحة الأحساء المسجلة في اليونسكو", en: "palm trees in the UNESCO-listed Al-Ahsa oasis" },
  "stats.festival": { ar: "أكبر مهرجان للتمور في العالم — بريدة، القصيم", en: "world's largest date festival — Buraidah, Al-Qassim" },
  "stats.routes": { ar: "طريقان تجاريان قديمان حملا التمور عبر الجزيرة", en: "ancient trade routes carried dates across Arabia" },
  "stats.cta": { ar: "اكتشف الواحات على الخريطة", en: "Discover the oases on the map" },

  // Footer
  "footer.tagline": { ar: "إرث النخيل السعودي، بصياغة رقمية فاخرة", en: "The Saudi palm legacy, crafted digitally in luxury" },
  "footer.explore": { ar: "استكشف", en: "Explore" },
  "footer.rights": { ar: "© 2026 واحة التمور — جميع الحقوق محفوظة", en: "© 2026 Dates Oasis — All rights reserved" },
  "footer.poc": { ar: "النموذج التقني (POC)", en: "Technical POC" },

  // Placeholder pages
  "placeholder.map.title": { ar: "خريطة التراث ثلاثية الأبعاد", en: "3D Heritage Map" },
  "placeholder.map.desc": {
    ar: "تحليق سينمائي فوق واحات المملكة وطرق التجارة القديمة — تُطلق في المرحلة الثانية",
    en: "Cinematic flights over the Kingdom's oases and ancient trade routes — launching in Phase 2",
  },
  "placeholder.knowledge.title": { ar: "بحث المعرفة الذكي", en: "AI Knowledge Search" },
  "placeholder.knowledge.desc": {
    ar: "اسأل بالعربية أو الإنجليزية عن التمور والواحات والتراث — تُطلق في المرحلة الثانية",
    en: "Ask in Arabic or English about dates, oases and heritage — launching in Phase 2",
  },
  "placeholder.provenance.title": { ar: "وثيق — الشهادات", en: "Watheeq — Certificates" },
  "placeholder.provenance.desc": {
    ar: "شهادات محصول رقمية موثقة برمز QR لمزارعي التمور — تُطلق في المرحلة الثانية",
    en: "QR-verified digital origin certificates for date farmers — launching in Phase 2",
  },
  "placeholder.soon": { ar: "قريباً — المرحلة الثانية", en: "Coming Soon — Phase 2" },
  "placeholder.back": { ar: "العودة للرئيسية", en: "Back to Home" },
  "placeholder.try_poc": { ar: "جرّب النموذج التقني الآن", en: "Try the technical POC now" },

  // Map page (Phase 2)
  "map.list": { ar: "استكشف المواقع والطرق", en: "Explore locations & routes" },
  "map.locations": { ar: "المواقع", en: "Locations" },
  "map.routes_label": { ar: "طرق التجارة", en: "Trade Routes" },
  "map.reset": { ar: "إعادة العرض", en: "Reset view" },
  "map.legend": { ar: "مفتاح الخريطة", en: "Legend" },
  "map.legend.oasis": { ar: "واحات", en: "Oases" },
  "map.legend.heritage": { ar: "مواقع تراثية", en: "Heritage sites" },
  "map.legend.route": { ar: "طرق تجارية", en: "Trade routes" },
  "map.related": { ar: "أصناف مرتبطة:", en: "Related varieties:" },
  "map.nowebgl": {
    ar: "متصفحك لا يدعم WebGL — لا يمكن عرض الخريطة ثلاثية الأبعاد، لكن بقية المنصة تعمل بشكل كامل.",
    en: "Your browser doesn't support WebGL — the 3D map can't render, but the rest of the platform works fully.",
  },

  // Knowledge page (Phase 2)
  "knowledge.tag": { ar: "مدعوم بالذكاء الاصطناعي", en: "AI-Powered" },
  "knowledge.title": { ar: "بحث المعرفة التراثية", en: "Heritage Knowledge Search" },
  "knowledge.sub": {
    ar: "اسأل بالعربية أو الإنجليزية عن أصناف التمور والواحات وطرق التجارة والمطبخ التراثي — إجابات موثقة من موسوعتنا",
    en: "Ask in Arabic or English about date varieties, oases, trade routes and heritage cuisine — answers grounded in our encyclopedia",
  },
  "knowledge.placeholder": { ar: "اسأل عن تراث التمور...", en: "Ask about date heritage..." },
  "knowledge.button": { ar: "ابحث", en: "Search" },
  "knowledge.loading": { ar: "نبحث في الموسوعة ونصوغ الإجابة...", en: "Searching the encyclopedia and composing the answer..." },
  "knowledge.error": { ar: "تعذر تنفيذ البحث — حاول مرة أخرى", en: "Search failed — please try again" },
  "knowledge.warming": { ar: "محرك البحث الدلالي يستعد الآن — أعد المحاولة بعد لحظات.", en: "The semantic search engine is warming up — please retry in a moment." },
  "knowledge.network": { ar: "تعذر الوصول إلى الخادم — تحقق من اتصالك ثم أعد المحاولة.", en: "Could not reach the server — check your connection and retry." },
  "knowledge.retry": { ar: "إعادة المحاولة", en: "Retry" },
  "knowledge.sourcesOnly": { ar: "المصادر فقط — الإجابة الذكية غير متاحة مؤقتاً", en: "Sources only — AI answer temporarily unavailable" },
  "auth.google_retry": { ar: "إعادة محاولة تسجيل الدخول", en: "Retry sign-in" },
  "auth.google_back": { ar: "العودة إلى صفحة الدخول", en: "Back to sign-in page" },
  "err.GOOGLE_SESSION_INVALID": { ar: "انتهت صلاحية جلسة Google أو أنها غير صالحة — أعد محاولة تسجيل الدخول.", en: "The Google session is invalid or expired — please sign in again." },
  "err.GOOGLE_EXCHANGE_FAILED": { ar: "تعذر إتمام تسجيل الدخول بحساب Google — الخادم غير متاح مؤقتاً. أعد المحاولة بعد لحظات.", en: "Could not complete Google sign-in — the server is temporarily unavailable. Please retry in a moment." },
  "knowledge.answer": { ar: "الإجابة", en: "Answer" },
  "knowledge.sources": { ar: "المصادر", en: "Sources" },
  "knowledge.no_match.title": { ar: "لا توجد نتائج قوية الصلة", en: "No strong matches found" },
  "knowledge.try": { ar: "جرّب أحد هذه الأسئلة:", en: "Try one of these:" },
  "knowledge.view_map": { ar: "عرض على الخريطة", en: "View on map" },
  "knowledge.view_home": { ar: "اقرأ في الموسوعة", en: "Read in encyclopedia" },
  "knowledge.cat.variety": { ar: "صنف تمر", en: "Variety" },
  "knowledge.cat.oasis": { ar: "واحة", en: "Oasis" },
  "knowledge.cat.route": { ar: "طريق تجاري", en: "Trade route" },
  "knowledge.cat.culinary": { ar: "مطبخ تراثي", en: "Culinary" },
  "knowledge.cat.agriculture": { ar: "زراعة", en: "Agriculture" },
  "knowledge.cat.heritage": { ar: "تراث", en: "Heritage" },
  "knowledge.cat.culture": { ar: "ثقافة", en: "Culture" },
  "knowledge.cat.general": { ar: "عام", en: "General" },

  // Provenance landing (Phase 3)
  "prov.tag": { ar: "برنامج المحصول الموثق", en: "Certified Provenance Program" },
  "prov.title": { ar: "مركز المحصول — وثّق تمورك", en: "Provenance Hub — Certify Your Dates" },
  "prov.sub": {
    ar: "سجّل مزرعتك، ووثّق محاصيل التمور بموقعها الجغرافي، واحصل على شهادات أصالة ذهبية برمز QR يمكن لأي مشترٍ التحقق منها فوراً",
    en: "Register your farm, document date yields with geospatial origin, and receive gold authenticity certificates with QR verification any buyer can trust instantly",
  },
  "prov.cta_register": { ar: "سجّل مزرعتك الآن", en: "Register Your Farm" },
  "prov.cta_login": { ar: "تسجيل الدخول", en: "Log In" },
  "prov.cta_dashboard": { ar: "لوحة التحكم", en: "Go to Dashboard" },
  "prov.b1.title": { ar: "أصالة جغرافية", en: "Geospatial Authenticity" },
  "prov.b1.desc": {
    ar: "كل شهادة تحمل إحداثيات المزرعة الدقيقة والمنطقة المشتقة تلقائياً",
    en: "Every certificate carries precise farm coordinates and an auto-derived region",
  },
  "prov.b2.title": { ar: "مناطق تراث اليونسكو", en: "UNESCO Heritage Regions" },
  "prov.b2.desc": {
    ar: "تموركم من واحات مسجلة عالمياً — الأحساء والقصيم والمدينة",
    en: "Dates from globally recognized oases — Al-Ahsa, Al-Qassim, Al-Madinah",
  },
  "prov.b3.title": { ar: "ثقة برمز QR", en: "QR-Powered Trust" },
  "prov.b3.desc": {
    ar: "رمز QR على كل شهادة يفتح صفحة تحقق عامة فورية",
    en: "A QR code on every certificate opens an instant public verification page",
  },

  // Auth
  "auth.login_title": { ar: "تسجيل دخول المزارعين", en: "Farmer Login" },
  "auth.register_title": { ar: "تسجيل مزرعة جديدة", en: "Register New Farm" },
  "auth.tab_login": { ar: "دخول", en: "Log In" },
  "auth.tab_register": { ar: "تسجيل جديد", en: "Register" },
  "auth.name": { ar: "الاسم الكامل", en: "Full name" },
  "auth.email": { ar: "البريد الإلكتروني", en: "Email" },
  "auth.password": { ar: "كلمة المرور (8 أحرف على الأقل)", en: "Password (min 8 chars)" },
  "auth.farm": { ar: "اسم المزرعة", en: "Farm name" },
  "auth.region": { ar: "المنطقة", en: "Region" },
  "auth.submit_login": { ar: "دخول", en: "Log In" },
  "auth.submit_register": { ar: "إنشاء الحساب", en: "Create Account" },
  "auth.working": { ar: "لحظات...", en: "Working..." },

  // API error codes (bilingual)
  "err.GENERIC": { ar: "حدث خطأ — حاول مرة أخرى", en: "Something went wrong — try again" },
  "err.EMAIL_EXISTS": { ar: "هذا البريد مسجل مسبقاً — سجّل الدخول بدلاً من ذلك", en: "This email is already registered — log in instead" },
  "err.INVALID_CREDENTIALS": { ar: "بيانات الدخول غير صحيحة", en: "Invalid email or password" },
  "err.SECURITY_MISSING": { ar: "لم يكتمل التحقق الأمني — أعد المحاولة", en: "Security check incomplete — please retry" },
  "err.SECURITY_FAILED": { ar: "فشل التحقق الأمني — أعد المحاولة", en: "Security check failed — please retry" },
  "err.SECURITY_EXPIRED": { ar: "انتهت صلاحية التحقق الأمني — أعد المحاولة", en: "Security check expired — please retry" },
  "err.SECURITY_TOO_FAST": { ar: "أُرسل النموذج بسرعة غير معتادة — انتظر لحظة ثم أعد المحاولة", en: "Form submitted unusually fast — wait a moment and retry" },
  "err.FARM_NOT_FOUND": { ar: "المزرعة غير موجودة", en: "Farm not found" },
  "err.FARM_HAS_YIELDS": { ar: "لا يمكن حذف مزرعة لها محاصيل موثقة — يمكنك أرشفتها", en: "A farm with certified yields cannot be deleted — archive it instead" },
  "err.FARM_IS_DEFAULT": { ar: "اختر مزرعة أخرى كافتراضية أولاً", en: "Set another farm as default first" },
  "err.FARM_ARCHIVED": { ar: "هذه المزرعة مؤرشفة", en: "This farm is archived" },
  "err.FARM_LIMIT": { ar: "بلغت الحد الأقصى لعدد المزارع", en: "Farm limit reached" },
  "sec.note": { ar: "محمي بتحقق أمني صامت — لا حاجة لأي خطوة إضافية", en: "Protected by a silent security check — no extra step needed" },
  "farms.tab": { ar: "مزارعي", en: "My Farms" },
  "farms.title": { ar: "مزارعي", en: "My farms" },
  "farms.sub": { ar: "أدر مواقع مزارعك المتعددة تحت حساب واحد — كل شهادة تُنسب إلى مزرعة محددة.", en: "Manage several farm locations under one account — every certificate is attributed to a specific farm." },
  "farms.add": { ar: "إضافة مزرعة", en: "Add farm" },
  "farms.edit": { ar: "تعديل المزرعة", en: "Edit farm" },
  "farms.name": { ar: "اسم المزرعة", en: "Farm name" },
  "farms.nameEn": { ar: "الاسم بالإنجليزية (اختياري)", en: "English name (optional)" },
  "farms.notes": { ar: "ملاحظات", en: "Notes" },
  "farms.default": { ar: "الافتراضية", en: "Default" },
  "farms.setDefault": { ar: "تعيين كافتراضية", en: "Set as default" },
  "farms.archive": { ar: "أرشفة", en: "Archive" },
  "farms.unarchive": { ar: "إلغاء الأرشفة", en: "Unarchive" },
  "farms.archived": { ar: "مؤرشفة", en: "Archived" },
  "farms.delete": { ar: "حذف", en: "Delete" },
  "farms.deleteTitle": { ar: "حذف المزرعة؟", en: "Delete farm?" },
  "farms.deleteDesc": { ar: "يمكن حذف المزارع التي لا تحمل محاصيل فقط.", en: "Only farms without yields can be deleted." },
  "farms.archiveTitle": { ar: "أرشفة المزرعة؟", en: "Archive farm?" },
  "farms.archiveDesc": { ar: "ستختفي من معالج التوثيق، وتبقى شهاداتها وسجلها كما هي.", en: "It disappears from the certify wizard; its certificates and history stay intact." },
  "farms.saved": { ar: "تم حفظ المزرعة", en: "Farm saved" },
  "farms.deleted": { ar: "تم حذف المزرعة", en: "Farm deleted" },
  "farms.yields": { ar: "محاصيل", en: "yields" },
  "farms.all": { ar: "كل المزارع", en: "All farms" },
  "farms.filter": { ar: "المزرعة", en: "Farm" },
  "farms.pickLocation": { ar: "موقع المزرعة على الخريطة (اختياري)", en: "Farm location on the map (optional)" },
  "farms.empty": { ar: "لا مزارع بعد — أضف مزرعتك الأولى", en: "No farms yet — add your first farm" },
  "farms.count": { ar: "المزارع", en: "Farms" },
  "farms.owner": { ar: "المالك", en: "Owner" },
  "wz.step.farm": { ar: "المزرعة", en: "Farm" },
  "wz.err.farm": { ar: "اختر المزرعة", en: "Choose a farm" },
  "a7.nav.farms": { ar: "المزارع", en: "Farms" },
  "a7.nav.cultivars": { ar: "دليل الأصناف", en: "Cultivars" },
  "ai.suggest": { ar: "اقتراح بالذكاء الاصطناعي", en: "AI Suggest" },
  "ai.title": { ar: "مسوّدة جديدة بالذكاء الاصطناعي", en: "New AI-generated draft" },
  "ai.desc": { ar: "سيولّد المساعد مسوّدة ثنائية اللغة كاملة تفتح في المحرر للمراجعة قبل الحفظ.", en: "The assistant generates a complete bilingual draft that opens in the editor for your review before saving." },
  "ai.hint": { ar: "تلميح الموضوع (اختياري)", en: "Topic hint (optional)" },
  "ai.hintPh": { ar: "مثال: تمور تبوك، حلوى الكليجا، طريق الحج الكوفي…", en: "e.g. Tabuk dates, Kleija sweets, the Kufi pilgrim road…" },
  "ai.generate": { ar: "توليد المسوّدة", en: "Generate draft" },
  "ai.generating": { ar: "جارٍ التوليد…", en: "Generating…" },
  "ai.ready": { ar: "فُتحت المسوّدة في المحرر — راجعها ثم احفظ", en: "Draft opened in the editor — review, then save" },
  "ai.failed": { ar: "تعذّر توليد الاقتراح — أعد المحاولة", en: "Could not generate a suggestion — please retry" },
  "ai.badOutput": { ar: "أعاد المساعد مخرجات غير صالحة — أعد التوليد", en: "The assistant returned invalid output — regenerate" },
  "ai.rateLimit": { ar: "بلغت حد الاقتراحات لهذه الساعة (10)", en: "Hourly suggestion limit reached (10)" },
  "ai.fun1": { ar: "نتصفح واحات الأحساء والقصيم…", en: "Wandering the oases of Al-Ahsa and Al-Qassim…" },
  "ai.fun2": { ar: "نستشير كبار النخّالة…", en: "Consulting the elder palm-keepers…" },
  "ai.fun3": { ar: "نصقل الفصحى والإنجليزية…", en: "Polishing the Arabic and the English…" },
  "dir.tag": { ar: "دليل الأصناف", en: "Varieties Directory" },
  "dir.crumb": { ar: "الدليل", en: "Directory" },
  "dir.title": { ar: "دليل الأصناف السعودية — 76 صنفاً", en: "Saudi Cultivar Directory — 76 Cultivars" },
  "dir.sub": { ar: "المنطقة المرتبطة، نافذة الرطب والتمر، القوام ومناطق الزراعة لكل صنف — ابحث وصفِّ بحسب المنطقة والموسم والقوام.", en: "Associated region, rutab and tamr windows, texture and growing locations for every cultivar — search and filter by region, season and texture." },
  "dir.bannerTitle": { ar: "استكشف الأصناف الـ 76 كلها", en: "Explore all 76 cultivars" },
  "dir.bannerSub": { ar: "دليل ثنائي اللغة قابل للبحث والتصفية — من الخلاص إلى رطب نجران", en: "A searchable, filterable bilingual directory — from Khalas to Najran Rutab" },
  "dir.searchPh": { ar: "ابحث بالاسم أو المنطقة أو القوام…", en: "Search by name, region or texture…" },
  "dir.allRegions": { ar: "كل المناطق", en: "All regions" },
  "dir.allSeasons": { ar: "كل المواسم", en: "All seasons" },
  "dir.allTextures": { ar: "كل الأقوام", en: "All textures" },
  "dir.reset": { ar: "مسح الفلاتر", en: "Clear filters" },
  "dir.empty": { ar: "لا نتائج مطابقة — جرّب كلمة أخرى أو امسح الفلاتر", en: "No matching cultivars — try another word or clear the filters" },
  "dir.origin": { ar: "الأصل / الارتباط", en: "Origin / association" },
  "dir.seasonWindow": { ar: "الموسم والحصاد", en: "Season & harvest" },
  "dir.season": { ar: "الموسم", en: "Season" },
  "dir.texture": { ar: "القوام", en: "Texture" },
  "dir.locations": { ar: "مناطق الزراعة", en: "Growing locations" },
  "dir.profile": { ar: "نبذة", en: "Profile" },
  "dir.region": { ar: "المنطقة", en: "Region" },
  "dir.featured": { ar: "صفحة مميزة مرتبطة (slug)", en: "Linked featured page (slug)" },
  "dir.readFeatured": { ar: "اقرأ الصفحة الكاملة للصنف", en: "Read the full variety page" },
  "dir.note": { ar: "التواريخ الموسمية نوافذ زراعية تقريبية تتغير بحسب الحرارة والموقع والسنة. المصادر: وزارة البيئة والمياه والزراعة، واس، سعوديبيديا، المركز الوطني للنخيل والتمور.", en: "Seasonal dates are indicative agricultural windows that shift with heat, location and year. Sources: Saudi MEWA, SPA, Saudipedia, National Center for Palms & Dates." },
  "dir.s.early": { ar: "مبكر", en: "Early" },
  "dir.s.mid": { ar: "متوسط", en: "Mid-season" },
  "dir.s.late": { ar: "متأخر", en: "Late" },
  "dir.t.soft": { ar: "لين", en: "Soft" },
  "dir.t.semi-dry": { ar: "نصف جاف", en: "Semi-dry" },
  "dir.t.dry": { ar: "جاف", en: "Dry" },
  "dir.r.alahsa": { ar: "الأحساء", en: "Al-Ahsa" },
  "dir.r.qassim": { ar: "القصيم", en: "Al-Qassim" },
  "dir.r.madinah": { ar: "المدينة المنورة", en: "Madinah" },
  "dir.r.riyadh": { ar: "الرياض", en: "Riyadh" },
  "dir.r.eastern": { ar: "الشرقية", en: "Eastern Province" },
  "dir.r.tabuk": { ar: "تبوك", en: "Tabuk" },
  "dir.r.najran": { ar: "نجران", en: "Najran" },
  "dir.r.hail": { ar: "حائل", en: "Hail" },
  "dir.r.aljouf": { ar: "الجوف", en: "Al-Jouf" },
  "dir.r.makkah": { ar: "مكة المكرمة", en: "Makkah" },
  "dir.r.jazan": { ar: "جازان", en: "Jazan" },
  "dir.r.asir": { ar: "عسير", en: "Asir" },
  "dir.r.albaha": { ar: "الباحة", en: "Al-Baha" },
  "dir.r.bisha": { ar: "بيشة", en: "Bisha" },
  "dir.r.kharj": { ar: "الخرج", en: "Al-Kharj" },
  "dir.r.dawasir": { ar: "وادي الدواسر", en: "Wadi Al-Dawasir" },
  "dir.r.other": { ar: "مناطق أخرى", en: "Other regions" },
  "dir.createPage": { ar: "إنشاء صفحة", en: "Create Page" },
  "dir.linked": { ar: "تم ربط الصنف بالصفحة الجديدة في الدليل", en: "Directory entry linked to the new page" },
  "share.card": { ar: "مشاركة كصورة", en: "Share as Image" },
  "share.cardTitle": { ar: "بطاقة الشهادة للمشاركة", en: "Shareable certificate card" },
  "share.cardSub": { ar: "بطاقة أنيقة بحجم المحفظة — مثالية لواتساب ومعرض الصور", en: "A wallet-size brand card — perfect for WhatsApp and photo galleries" },
  "share.share": { ar: "مشاركة الصورة", en: "Share image" },
  "share.download": { ar: "تنزيل PNG", en: "Download PNG" },
  "share.generating": { ar: "جارٍ إنشاء الصورة…", en: "Generating image…" },
  "share.shared": { ar: "تمت المشاركة", en: "Shared" },
  "share.downloaded": { ar: "تم تنزيل بطاقة الشهادة", en: "Certificate card downloaded" },
  "share.failed": { ar: "تعذّر إنشاء الصورة — حاول مجدداً", en: "Couldn't generate the image — try again" },
  "nav.souq": { ar: "السوق", en: "Souq" },
  "wq.tab.souq": { ar: "السوق", en: "Souq" },
  "a7.nav.watheeq": { ar: "وثيق", en: "Watheeq" },
  "a7.nav.souqgrp": { ar: "السوق", en: "Souq" },
  "a7.nav.souq": { ar: "السوق والطلبات", en: "Souq & Orders" },
  "a7.nav.regions": { ar: "مناطق التمور", en: "Regions" },
  "a7.nav.analytics": { ar: "تحليلات المواسم", en: "Season Analytics" },
  "wq.tab.analytics": { ar: "التحليلات", en: "Analytics" },
  "an.title": { ar: "تحليلات المواسم", en: "Season Analytics" },
  "an.season": { ar: "موسم", en: "Season" },
  "an.totalKg": { ar: "إجمالي المحصول (كجم)", en: "Total harvest (kg)" },
  "an.orders": { ar: "الطلبات", en: "Orders" },
  "an.gross": { ar: "إجمالي المبيعات", en: "Gross sales" },
  "an.net": { ar: "صافي المزارع", en: "Net to farmer" },
  "an.fees": { ar: "رسوم المنصة المحصلة", en: "Platform fees collected" },
  "an.listings": { ar: "المزادات", en: "Listings" },
  "an.empty": { ar: "لا توجد بيانات لهذا الموسم بعد — سجّل محصولاً لتبدأ التحليلات", en: "No data for this season yet — record a harvest to start your analytics" },
  "an.kgChart": { ar: "حجم المحصول حسب الصنف لكل موسم", en: "Harvest volume by variety per season" },
  "an.moneyChart": { ar: "المبيعات والصافي لكل موسم (ر.س)", en: "Sales & net per season (SAR)" },
  "an.byVariety": { ar: "تفصيل حسب الصنف", en: "Variety breakdown" },
  "an.variety": { ar: "الصنف", en: "Variety" },
  "an.kg": { ar: "كجم", en: "kg" },
  "an.trend": { ar: "اتجاه المبيعات عبر المواسم", en: "Gross sales trend across seasons" },
  "an.thisSeason": { ar: "الموسم المحدد", en: "Selected season" },
  "an.allTime": { ar: "كل المواسم", en: "All-time" },
  "an.farm": { ar: "المزرعة", en: "Farm" },
  "an.region": { ar: "المنطقة", en: "Region" },
  "an.farmer": { ar: "المزارع", en: "Farmer" },
  "an.group.farm": { ar: "حسب المزرعة", en: "By farm" },
  "an.group.region": { ar: "حسب المنطقة", en: "By region" },
  "an.group.variety": { ar: "حسب الصنف", en: "By variety" },
  "a7.nav.payouts": { ar: "دفتر التحويلات", en: "Payouts" },
  "wq.tab.payouts": { ar: "التحويلات", en: "Payouts" },
  "po.title": { ar: "دفتر التحويلات الشهري", en: "Monthly Payout Ledger" },
  "po.adminTitle": { ar: "دفتر تحويلات المزارعين", en: "Farmer Payout Ledger" },
  "po.hint": { ar: "الأرقام محسوبة من الطلبات المدفوعة فقط. يُحوَّل صافي كل شهر إلى حسابك بعد التسوية.", en: "Figures are computed from paid orders only. Each month's net is transferred to your account after settlement." },
  "bank.title": { ar: "بيانات الحساب البنكي", en: "Bank details" },
  "bank.desc": { ar: "يُحوَّل صافي مستحقاتك إلى هذا الحساب. رقم الآيبان مرئي لك ولإدارة المنصة فقط.", en: "Your net payouts are transferred to this account. The IBAN is visible only to you and platform admins." },
  "bank.nudge": { ar: "لديك مبيعات مدفوعة ولم تُضِف بيانات حسابك البنكي بعد — أضفها ليتم تحويل مستحقاتك.", en: "You have paid sales but no bank details yet — add them so your payouts can be transferred." },
  "bank.holder": { ar: "اسم صاحب الحساب (كما في البنك)", en: "Account holder (as at bank)" },
  "bank.bank": { ar: "البنك", en: "Bank" },
  "bank.otherName": { ar: "اسم البنك", en: "Bank name" },
  "bank.other": { ar: "بنك آخر", en: "Other bank" },
  "bank.save": { ar: "حفظ بيانات الحساب", en: "Save bank details" },
  "bank.saved": { ar: "تم حفظ بيانات الحساب البنكي", en: "Bank details saved" },
  "bank.copied": { ar: "تم نسخ الآيبان", en: "IBAN copied" },
  "bank.ibanValid": { ar: "آيبان سعودي صالح", en: "Valid Saudi IBAN" },
  "bank.column": { ar: "الحساب البنكي", en: "Bank account" },
  "bank.missing": { ar: "لا توجد بيانات بنكية", en: "No bank details" },
  "bank.onFile": { ar: "مسجّل", en: "On file" },
  "bank.transferTo": { ar: "التحويل إلى", en: "Transfer to" },
  "bank.name.alrajhi": { ar: "مصرف الراجحي", en: "Al Rajhi Bank" },
  "bank.name.snb": { ar: "البنك الأهلي السعودي", en: "Saudi National Bank (SNB)" },
  "bank.name.riyad": { ar: "بنك الرياض", en: "Riyad Bank" },
  "bank.name.sab": { ar: "البنك السعودي الأول", en: "Saudi Awwal Bank (SAB)" },
  "bank.name.alinma": { ar: "مصرف الإنماء", en: "Alinma Bank" },
  "bank.name.albilad": { ar: "بنك البلاد", en: "Bank Albilad" },
  "bank.name.anb": { ar: "البنك العربي الوطني", en: "Arab National Bank" },
  "bank.name.bsf": { ar: "البنك السعودي الفرنسي", en: "Banque Saudi Fransi" },
  "bank.name.aljazira": { ar: "بنك الجزيرة", en: "Bank AlJazira" },
  "bank.name.gib": { ar: "بنك الخليج الدولي", en: "Gulf International Bank" },
  "bank.name.stc_pay": { ar: "إس تي سي بنك", en: "STC Bank" },
  "bank.name.other": { ar: "بنك آخر", en: "Other" },
  "err.IBAN_REQUIRED": { ar: "رقم الآيبان مطلوب", en: "IBAN is required" },
  "err.IBAN_NOT_SAUDI": { ar: "يجب أن يكون الآيبان سعودياً ويبدأ بـ SA", en: "IBAN must be Saudi (starts with SA)" },
  "err.IBAN_FORMAT": { ar: "صيغة الآيبان غير صحيحة: SA ثم 22 رقماً (24 خانة)", en: "Invalid IBAN format: SA followed by 22 digits (24 characters)" },
  "err.IBAN_CHECKSUM": { ar: "رقم الآيبان غير صالح (فشل التحقق من أرقام الرقابة)", en: "Invalid IBAN (check digits failed)" },
  "err.BANK_INVALID": { ar: "البنك المحدد غير معروف", en: "Unknown bank selected" },
  "err.BANK_OTHER_REQUIRED": { ar: "يرجى كتابة اسم البنك", en: "Please enter the bank name" },
  "po.empty": { ar: "لا توجد مبيعات مدفوعة بعد — عند إتمام أول عملية بيع في السوق سيظهر سجلك هنا", en: "No paid sales yet — your ledger appears here after your first completed Souq sale" },
  "po.totalNet": { ar: "إجمالي الصافي", en: "Total net" },
  "po.pending": { ar: "بانتظار التحويل", en: "Pending transfer" },
  "po.transferred": { ar: "تم تحويله", en: "Transferred" },
  "po.paidOrders": { ar: "طلبات مدفوعة", en: "Paid orders" },
  "po.orders": { ar: "طلبات", en: "orders" },
  "po.status.pending": { ar: "قيد الانتظار", en: "Pending" },
  "po.status.transferred": { ar: "تم التحويل", en: "Transferred" },
  "po.transferredOn": { ar: "تم التحويل بتاريخ", en: "Transferred on" },
  "po.reference": { ar: "المرجع", en: "Reference" },
  "po.note": { ar: "ملاحظة", en: "Note" },
  "po.paidAt": { ar: "تاريخ الدفع", en: "Paid at" },
  "po.order": { ar: "الطلب", en: "Order" },
  "po.buyer": { ar: "المشتري", en: "Buyer" },
  "po.settlement": { ar: "التسوية", en: "Settlement" },
  "po.exportCsv": { ar: "تصدير CSV", en: "Export CSV" },
  "po.csvOk": { ar: "تم تنزيل ملف CSV", en: "CSV downloaded" },
  "po.dlFail": { ar: "تعذّر التنزيل", en: "Download failed" },
  "po.month": { ar: "الشهر", en: "Month" },
  "po.allMonths": { ar: "كل الأشهر", en: "All months" },
  "po.all": { ar: "الكل", en: "All" },
  "po.statusCol": { ar: "حالة التحويل", en: "Payout status" },
  "po.farmers": { ar: "مزارعون", en: "Farmers" },
  "po.pendingRows": { ar: "أشهر بانتظار التحويل", en: "Months pending" },
  "po.mark": { ar: "تأكيد التحويل", en: "Mark transferred" },
  "po.markTitle": { ar: "تأكيد تحويل المستحقات", en: "Confirm payout transfer" },
  "po.markConfirm": { ar: "تأكيد التحويل", en: "Confirm transfer" },
  "po.transferDate": { ar: "تاريخ التحويل", en: "Transfer date" },
  "po.markedOk": { ar: "تم تسجيل التحويل", en: "Transfer recorded" },
  "po.revert": { ar: "تراجع", en: "Revert" },
  "po.revertTitle": { ar: "التراجع عن حالة التحويل؟", en: "Revert transfer status?" },
  "po.revertDesc": { ar: "سيعود هذا الشهر إلى حالة «قيد الانتظار» ويُسجَّل التراجع في سجل التدقيق.", en: "This month returns to Pending; the reversal is written to the audit trail." },
  "po.revertedOk": { ar: "تم التراجع", en: "Reverted to pending" },
  "region.title": { ar: "مناطق التمور السعودية", en: "Saudi Date Regions" },
  "region.subtitle": { ar: "من واحات الأحساء إلى نخيل الجوف — لكل منطقة حكاية وأصناف ومزادات", en: "From Al-Ahsa's oases to Al-Jouf's palms — every region has its story, cultivars and auctions" },
  "region.notFound": { ar: "هذه المنطقة غير موجودة", en: "Region not found" },
  "region.back": { ar: "كل المناطق", en: "All regions" },
  "region.viewMap": { ar: "شاهدها على الخريطة ثلاثية الأبعاد", en: "View on the 3D Map" },
  "region.openPage": { ar: "بوابة المنطقة", en: "Region page" },
  "region.heritage": { ar: "إرث المنطقة", en: "Regional heritage" },
  "region.varieties": { ar: "أصناف مميزة", en: "Signature varieties" },
  "region.varietiesN": { ar: "صنف مميز", en: "featured varieties" },
  "region.cultivarsN": { ar: "سلالة في الدليل", en: "directory cultivars" },
  "region.farmsN": { ar: "مزرعة موثقة", en: "registered farms" },
  "region.listingsN": { ar: "مزاد نشط", en: "live auctions" },
  "region.fromRegion": { ar: "من هذه المنطقة في السوق", en: "From this region in the Souq" },
  "region.browseSouq": { ar: "تصفّح كل المزادات", en: "Browse all auctions" },
  "regadmin.title": { ar: "بوابات المناطق", en: "Region pages" },
  "regadmin.edit": { ar: "تحرير", en: "Edit" },
  "regadmin.tagline": { ar: "الشعار التعريفي", en: "Tagline" },
  "regadmin.intro": { ar: "مقدمة التراث", en: "Heritage intro" },
  "regadmin.hero": { ar: "صورة الغلاف", en: "Hero image" },
  "regadmin.save": { ar: "حفظ", en: "Save" },
  "regadmin.saved": { ar: "تم حفظ صفحة المنطقة", en: "Region page saved" },
  "regadmin.cancel": { ar: "إغلاق", en: "Close" },
  "regadmin.view": { ar: "عرض الصفحة", en: "View page" },
  "souq.mark": { ar: "سوق واحة التمور", en: "Dates Oasis Souq" },
  "souq.title": { ar: "سوق التمور", en: "The Date Souq" },
  "souq.subtitle": { ar: "مزادات محاصيل التمور مباشرة من المزارعين — موثقة بشهادات وثيق", en: "Auctions of date harvests direct from farmers — backed by Watheeq certificates" },
  "souq.empty": { ar: "لا توجد مزادات مطابقة حالياً", en: "No matching auctions right now" },
  "souq.notFound": { ar: "هذا المزاد غير موجود", en: "This auction was not found" },
  "souq.back": { ar: "العودة إلى السوق", en: "Back to the Souq" },
  "souq.browse": { ar: "تصفّح السوق", en: "Browse the Souq" },
  "souq.filters.variety": { ar: "الصنف", en: "Variety" },
  "souq.filters.region": { ar: "المنطقة", en: "Region" },
  "souq.filters.all": { ar: "الكل", en: "All" },
  "souq.sort.ending": { ar: "ينتهي قريباً", en: "Ending soon" },
  "souq.sort.price_asc": { ar: "السعر: الأقل أولاً", en: "Price: low to high" },
  "souq.sort.price_desc": { ar: "السعر: الأعلى أولاً", en: "Price: high to low" },
  "souq.sort.newest": { ar: "الأحدث", en: "Newest" },
  "souq.currentBid": { ar: "المزايدة الحالية", en: "Current bid" },
  "souq.startingPrice": { ar: "سعر البداية", en: "Starting price" },
  "souq.buyNow": { ar: "شراء فوري", en: "Buy Now" },
  "souq.endsIn": { ar: "ينتهي", en: "Ends" },
  "souq.ended": { ar: "انتهى", en: "Ended" },
  "souq.verified": { ar: "موثّق وثيق", en: "Watheeq Verified" },
  "souq.verifiedFull": { ar: "محصول موثّق — اعرض الشهادة", en: "Watheeq Verified — view certificate" },
  "souq.bids": { ar: "مزايدة", en: "bids" },
  "souq.bid1": { ar: "مزايدة واحدة", en: "bid" },
  "souq.yourBid": { ar: "مزايدتك", en: "Your bid" },
  "souq.placeBid": { ar: "زايد الآن", en: "Place bid" },
  "souq.minBid": { ar: "الحد الأدنى", en: "Minimum" },
  "souq.bidPlaced": { ar: "تم تسجيل مزايدتك", en: "Your bid was placed" },
  "souq.boughtNow": { ar: "تم الشراء الفوري — بانتظار قبول المزارع", en: "Bought via Buy Now — awaiting farmer acceptance" },
  "souq.history": { ar: "سجل المزايدات", en: "Bid history" },
  "souq.noBids": { ar: "لا مزايدات بعد — كن الأول", en: "No bids yet — be the first" },
  "souq.loginToBid": { ar: "سجّل كمشترٍ للمزايدة على هذا المحصول", en: "Sign in as a buyer to bid on this harvest" },
  "souq.signupBuyer": { ar: "دخول / تسجيل مشترٍ", en: "Buyer sign in / sign up" },
  "souq.buyersOnlyNote": { ar: "المزايدة متاحة لحسابات المشترين فقط", en: "Bidding is available to buyer accounts only" },
  "souq.buyNowConfirmTitle": { ar: "تأكيد الشراء الفوري", en: "Confirm Buy Now" },
  "souq.buyNowConfirmDesc": { ar: "سينتهي المزاد فوراً وتصبح الفائز بهذا المحصول", en: "The auction ends immediately and you become the winner of this lot" },
  "souq.confirm": { ar: "تأكيد", en: "Confirm" },
  "souq.cancelBtn": { ar: "إلغاء", en: "Cancel" },
  "souq.harvest": { ar: "الحصاد", en: "Harvest" },
  "souq.farm": { ar: "المزرعة", en: "Farm" },
  "souq.u.d": { ar: "ي", en: "d" },
  "souq.u.h": { ar: "س", en: "h" },
  "souq.u.m": { ar: "د", en: "m" },
  "souq.u.s": { ar: "ث", en: "s" },
  "souq.timeLeft": { ar: "الوقت المتبقي", en: "Time left" },
  "souq.highest": { ar: "الأعلى", en: "Highest" },
  "souq.sellerVerifiedTrader": { ar: "بائع: تاجر موثّق", en: "Seller: verified trader" },
  "rt.now": { ar: "الآن", en: "just now" },
  "rt.m": { ar: "قبل {n} د", en: "{n}m ago" },
  "rt.h": { ar: "قبل {n} س", en: "{n}h ago" },
  "rt.d": { ar: "قبل {n} ي", en: "{n}d ago" },
  "vt.badge": { ar: "تاجر موثّق", en: "Verified Trader" },
  "vt.hint": { ar: "تاجر موثّق — تم التحقق من السجل التجاري", en: "Verified Trader — Commercial Registration checked" },
  "vt.title": { ar: "توثيق التاجر", en: "Trader verification" },
  "vt.desc": { ar: "احصل على علامة «تاجر موثّق» الفضية على عروضك بعد التحقق من سجلك التجاري السعودي.", en: "Earn the silver “Verified Trader” mark on your listings once your Saudi Commercial Registration is checked." },
  "vt.status.none": { ar: "غير موثّق", en: "Not verified" },
  "vt.status.pending": { ar: "قيد المراجعة", en: "Under review" },
  "vt.status.verified": { ar: "موثّق", en: "Verified" },
  "vt.status.rejected": { ar: "مرفوض", en: "Rejected" },
  "vt.status.revoked": { ar: "مُلغى", en: "Revoked" },
  "vt.business": { ar: "الاسم التجاري", en: "Business name" },
  "vt.businessAr": { ar: "الاسم التجاري (عربي)", en: "Business name (Arabic)" },
  "vt.businessEn": { ar: "الاسم التجاري (إنجليزي)", en: "Business name (English)" },
  "vt.cr": { ar: "رقم السجل التجاري", en: "CR number" },
  "vt.city": { ar: "المدينة", en: "City" },
  "vt.doc": { ar: "المستند", en: "Document" },
  "vt.docLabel": { ar: "صورة السجل التجاري (اختياري)", en: "CR document (optional)" },
  "vt.docHint": { ar: "PDF أو JPG/PNG/WebP حتى 5 م.ب — يُعرض للمشرف فقط", en: "PDF or JPG/PNG/WebP up to 5 MB — visible to admins only" },
  "vt.viewDoc": { ar: "عرض المستند", en: "View document" },
  "vt.submit": { ar: "إرسال طلب التوثيق", en: "Submit for verification" },
  "vt.sent": { ar: "تم إرسال طلب التوثيق — سنراجعه قريباً", en: "Verification request sent — we'll review it shortly" },
  "vt.adminTitle": { ar: "توثيق التجار", en: "Trader verifications" },
  "vt.revoke": { ar: "إلغاء التوثيق", en: "Revoke" },
  "vt.approveTitle": { ar: "اعتماد التاجر كموثّق؟", en: "Approve as Verified Trader?" },
  "vt.rejectTitle": { ar: "رفض طلب التوثيق؟", en: "Reject verification request?" },
  "vt.revokeTitle": { ar: "إلغاء توثيق التاجر؟", en: "Revoke trader verification?" },
  "vt.approveOk": { ar: "تم اعتماد التاجر", en: "Trader verified" },
  "vt.rejectOk": { ar: "تم رفض الطلب", en: "Request rejected" },
  "vt.revokeOk": { ar: "تم إلغاء التوثيق", en: "Verification revoked" },
  "a7.nav.trader-verifications": { ar: "توثيق التجار", en: "Trader Verifications" },
  "err.CR_INVALID": { ar: "رقم السجل التجاري غير صالح — 10 أرقام لا تبدأ بصفر", en: "Invalid CR number — 10 digits, not starting with 0" },
  "err.VERIFICATION_EXISTS": { ar: "لديك طلب توثيق قائم أو أنك موثّق بالفعل", en: "You already have a pending request or are already verified" },
  "err.TRADERS_ONLY": { ar: "هذه الخدمة لحسابات التجار فقط", en: "This service is for trader accounts only" },
  "err.UNSUPPORTED_TYPE": { ar: "نوع الملف غير مدعوم", en: "Unsupported file type" },
  "err.FILE_TOO_LARGE": { ar: "الملف أكبر من 5 م.ب", en: "File exceeds 5 MB" },
  "err.VERIFICATION_NOT_FOUND": { ar: "طلب التوثيق غير موجود", en: "Verification not found" },
  "err.ALREADY_DECIDED": { ar: "تم اتخاذ قرار في هذا الطلب سابقاً", en: "This request was already decided" },
  "err.NOT_VERIFIED": { ar: "هذا التاجر غير موثّق", en: "This trader is not verified" },
  "err.DOC_NOT_FOUND": { ar: "المستند غير موجود", en: "Document not found" },

  "souq.status.active": { ar: "مزاد نشط", en: "Active" },
  "souq.status.ended-pending": { ar: "انتهى — بانتظار قبول المزارع", en: "Ended — awaiting farmer acceptance" },
  "souq.status.sold": { ar: "مُباع", en: "Sold" },
  "souq.status.expired-unsold": { ar: "انتهى دون بيع", en: "Expired unsold" },
  "souq.status.closed-declined": { ar: "أُغلق — رفض المزارع", en: "Closed — declined" },
  "souq.status.cancelled": { ar: "أُلغي", en: "Cancelled" },
  "souq.status.removed": { ar: "أُزيل", en: "Removed" },
  "buyer.tab_register": { ar: "حساب مشترٍ جديد", en: "New buyer account" },
  "buyer.register_title": { ar: "انضم كمشترٍ", en: "Join as a buyer" },
  "buyer.submit_register": { ar: "إنشاء حساب مشترٍ", en: "Create buyer account" },
  "buyer.subtitle": { ar: "زايد على محاصيل موثقة مباشرة من المزارعين", en: "Bid on verified harvests direct from farmers" },
  "buyer.dash": { ar: "لوحة المشتري", en: "Buyer dashboard" },
  "buyer.myBids": { ar: "مزايداتي", en: "My bids" },
  "buyer.myPurchases": { ar: "مشترياتي", en: "My purchases" },
  "buyer.noBids": { ar: "لا مزايدات بعد", en: "No bids yet" },
  "buyer.noOrders": { ar: "لا مشتريات بعد", en: "No purchases yet" },
  "buyer.status.winning": { ar: "متصدر", en: "Winning" },
  "buyer.status.outbid": { ar: "تمت مجاوزتك", en: "Outbid" },
  "buyer.status.won": { ar: "فزت", en: "Won" },
  "buyer.status.lost": { ar: "لم تفز", en: "Lost" },
  "order.amount": { ar: "المبلغ", en: "Amount" },
  "order.status.pending_payment": { ar: "بانتظار الدفع", en: "Pending payment" },
  "order.status.paid": { ar: "مدفوع", en: "Paid" },
  "pay.now": { ar: "ادفع الآن", en: "Pay Now" },
  "pay.opening": { ar: "جارٍ فتح صفحة الدفع الآمنة…", en: "Opening secure checkout…" },
  "pay.invoice": { ar: "فاتورة التسوية PDF", en: "Settlement invoice PDF" },
  "pay.dlFail": { ar: "تعذّر تنزيل الفاتورة", en: "Couldn't download the invoice" },
  "pay.verifying": { ar: "جارٍ التحقق من الدفع لدى ميسر…", en: "Verifying your payment with Moyasar…" },
  "pay.successTitle": { ar: "تم الدفع بنجاح", en: "Payment successful" },
  "pay.successDesc": { ar: "تم توثيق دفعتك وإنشاء فاتورة التسوية — المحصول أصبح لك", en: "Your payment is verified and the settlement invoice is ready — the harvest is yours" },
  "pay.pendingTitle": { ar: "الدفع لم يكتمل بعد", en: "Payment not completed yet" },
  "pay.pendingDesc": { ar: "لم نستلم تأكيد الدفع — يمكنك المحاولة مجدداً في أي وقت", en: "We haven't received payment confirmation — you can retry anytime" },
  "pay.failedTitle": { ar: "تعذّر إتمام الدفع", en: "Payment failed" },
  "pay.failedDesc": { ar: "لم تُخصم أي مبالغ نهائية إلا بعد نجاح الدفع — حاول مجدداً ببطاقة صالحة", en: "Nothing is final until a successful payment — please retry with a valid card" },
  "pay.retry": { ar: "إعادة المحاولة والدفع", en: "Retry payment" },
  "pay.backToDash": { ar: "العودة إلى لوحة المشتري", en: "Back to buyer dashboard" },
  "pay.loginFirst": { ar: "سجّل الدخول بحساب المشتري لعرض حالة الطلب", en: "Sign in with your buyer account to view this order" },
  "pay.orderRef": { ar: "مرجع الطلب", en: "Order reference" },
  "err.PAYMENTS_UNAVAILABLE": { ar: "الدفع غير متاح مؤقتاً — حاول لاحقاً", en: "Payments are temporarily unavailable — try again later" },
  "err.ALREADY_PAID": { ar: "هذا الطلب مدفوع بالفعل", en: "This order is already paid" },
  "err.NOT_YOUR_ORDER": { ar: "هذا الطلب لا يخص حسابك", en: "This order doesn't belong to your account" },
  "err.ORDER_NOT_FOUND": { ar: "الطلب غير موجود", en: "Order not found" },
  "err.NOT_PAID": { ar: "الفاتورة تتاح بعد إتمام الدفع", en: "The invoice is available after payment" },
  "err.PAYMENT_CREATE_FAILED": { ar: "تعذّر إنشاء صفحة الدفع — حاول مجدداً", en: "Couldn't create the payment page — try again" },
  "err.PAYMENT_VERIFY_FAILED": { ar: "تعذّر التحقق من الدفع — حاول مجدداً", en: "Couldn't verify the payment — try again" },
  "fs.title": { ar: "مزاداتي في السوق", en: "My Souq listings" },
  "fs.new": { ar: "عرض محصول للمزاد", en: "List a harvest" },
  "fs.selectYield": { ar: "اختر المحصول", en: "Select yield" },
  "fs.noneAvailable": { ar: "كل محاصيلك معروضة حالياً — سجّل محصولاً جديداً أولاً", en: "All your yields are already listed — record a new yield first" },
  "fs.start": { ar: "سعر البداية", en: "Starting price" },
  "fs.buynow": { ar: "سعر الشراء الفوري (اختياري)", en: "Buy Now price (optional)" },
  "fs.duration": { ar: "مدة المزاد", en: "Auction duration" },
  "fs.days": { ar: "أيام", en: "days" },
  "fs.descAr": { ar: "وصف عربي (اختياري)", en: "Arabic description (optional)" },
  "fs.descEn": { ar: "وصف إنجليزي (اختياري)", en: "English description (optional)" },
  "fs.create": { ar: "إطلاق المزاد", en: "Launch auction" },
  "fs.created": { ar: "تم إطلاق المزاد في السوق", en: "Your auction is live in the Souq" },
  "fs.noListings": { ar: "لم تعرض أي محصول بعد", en: "You haven't listed any harvest yet" },
  "fs.cancel": { ar: "إلغاء المزاد", en: "Cancel listing" },
  "fs.cancelled": { ar: "أُلغي المزاد", en: "Listing cancelled" },
  "fs.accept": { ar: "قبول العرض", en: "Accept winner" },
  "fs.decline": { ar: "رفض", en: "Decline" },
  "fs.accepted": { ar: "تم القبول — أُنشئ الطلب بانتظار الدفع", en: "Accepted — order created, pending payment" },
  "fs.declined": { ar: "تم رفض العرض وإغلاق المزاد", en: "Winning bid declined, listing closed" },
  "fs.acceptTitle": { ar: "قبول العرض الفائز؟", en: "Accept the winning bid?" },
  "fs.acceptDesc": { ar: "سيُنشأ طلب بيع بحالة «بانتظار الدفع» مع احتساب عمولة المنصة", en: "A sale order will be created as pending payment with the platform fee snapshot" },
  "fs.winner": { ar: "الفائز", en: "Winner" },
  "fs.orders": { ar: "طلبات البيع", en: "Sale orders" },
  "fs.commission": { ar: "عمولة المنصة", en: "Platform fee" },
  "fs.vat": { ar: "ضريبة القيمة المضافة", en: "VAT" },
  "fs.net": { ar: "صافي المزارع", en: "Net to farmer" },
  "souqadmin.settings": { ar: "إعدادات رسوم السوق", en: "Souq fee settings" },
  "souqadmin.commission": { ar: "نسبة العمولة", en: "Commission" },
  "souqadmin.minfee": { ar: "الحد الأدنى للرسوم", en: "Minimum fee" },
  "souqadmin.vat": { ar: "نسبة الضريبة", en: "VAT" },
  "souqadmin.save": { ar: "حفظ الرسوم", en: "Save fees" },
  "souqadmin.saved": { ar: "تم حفظ إعدادات الرسوم", en: "Fee settings saved" },
  "souqadmin.note": { ar: "تُطبَّق التغييرات على الطلبات الجديدة فقط — الطلبات السابقة تحتفظ برسومها", en: "Changes apply to NEW orders only — past orders keep their fee snapshot" },
  "souqadmin.listings": { ar: "المزادات", en: "Listings" },
  "souqadmin.orders": { ar: "الطلبات", en: "Orders" },
  "souqadmin.buyer": { ar: "المشتري", en: "Buyer" },
  "souqadmin.payment": { ar: "مرجع الدفع", en: "Payment ID" },
  "souqadmin.remove": { ar: "إزالة", en: "Remove" },
  "souqadmin.removed": { ar: "تمت إزالة المزاد", en: "Listing removed" },
  "souqadmin.removeTitle": { ar: "إزالة هذا المزاد؟", en: "Remove this listing?" },
  "souqadmin.removeDesc": { ar: "سيختفي المزاد من السوق العام فوراً", en: "The listing disappears from the public Souq immediately" },
  "err.BUYERS_ONLY": { ar: "المزايدة متاحة لحسابات المشترين فقط", en: "Only buyer accounts can bid" },
  "err.NOT_AUTHORIZED_TO_BID": { ar: "حسابك غير مخوّل بالمزايدة — اطلب صلاحية المشتري من لوحتك", en: "Your account isn't authorized to bid — request buyer access from your dashboard" },
  "err.OWN_LISTING": { ar: "لا يمكنك المزايدة على مزاد من مزرعتك", en: "You cannot bid on your own farm's listing" },
  "err.REQUEST_EXISTS": { ar: "لديك طلب قائم أو صلاحية مفعّلة بالفعل", en: "You already have a pending request or active privilege" },
  "err.NOT_A_FARMER": { ar: "هذا الإجراء متاح لحسابات المزارعين فقط", en: "Only farmer accounts can do this" },
  "err.REQUEST_NOT_FOUND": { ar: "الطلب غير موجود", en: "Request not found" },
  "err.ALREADY_DECIDED": { ar: "تم البت في هذا الطلب مسبقاً", en: "This request was already decided" },
  "err.START_BELOW_CURRENT": { ar: "لا يمكن خفض سعر البداية تحت أعلى مزايدة حالية", en: "Starting price cannot go below the current highest bid" },
  "err.INVALID_END_TIME": { ar: "وقت الانتهاء غير صالح — يجب أن يكون في المستقبل", en: "Invalid end time — must be in the future" },
  "err.LISTING_NOT_ACTIVE": { ar: "المزاد غير نشط", en: "Listing is not active" },
  "souq.traderListing": { ar: "عرض تاجر", en: "Trader listing" },
  "souq.sellerTrader": { ar: "بائع: تاجر تمور", en: "Seller: dates trader" },
  "souq.sellerFarmer": { ar: "بائع: مزارع", en: "Seller: farmer" },
  "ua.register_title": { ar: "حساب واحد لكل خدمات الواحة", en: "One account for everything in the Oasis" },
  "ua.subtitle": { ar: "مزارع، تاجر أو مشترٍ — سجّل دخولك من هنا. يمكن إضافة أدوار أخرى لاحقاً.", en: "Farmer, trader or buyer — sign in here. More roles can be added to your account later." },
  "ua.type.buyer": { ar: "مشترٍ", en: "Buyer" },
  "ua.type.buyer.hint": { ar: "زايد واشترِ من السوق", en: "Bid & buy on the Souq" },
  "ua.type.farmer": { ar: "مزارع", en: "Farmer" },
  "ua.type.farmer.hint": { ar: "وثّق محاصيلك وبِعها", en: "Certify & sell your harvest" },
  "ua.type.trader": { ar: "تاجر", en: "Trader" },
  "ua.type.trader.hint": { ar: "بِع التمور دون مزرعة", en: "Sell dates without a farm" },
  "ua.traderName": { ar: "الاسم التجاري (اختياري)", en: "Business name (optional)" },
  "err.INVALID_ACCOUNT_TYPE": { ar: "نوع الحساب غير صالح", en: "Invalid account type" },
  "err.FARM_DETAILS_REQUIRED": { ar: "اسم المزرعة والمنطقة مطلوبان لحساب المزارع", en: "Farm name and region are required for a farmer account" },
  "err.TRADERS_ONLY": { ar: "هذه الخدمة لحسابات التجار", en: "This action is for trader accounts" },
  "err.INVALID_VARIETY": { ar: "صنف غير معروف", en: "Unknown variety" },
  "err.ROLES_REQUIRED": { ar: "يجب اختيار دور واحد على الأقل", en: "Select at least one role" },
  "err.CANNOT_DROP_OWN_ADMIN": { ar: "لا يمكنك إزالة صلاحية المدير عن حسابك", en: "You cannot remove your own admin role" },
  "role.admin": { ar: "مدير", en: "Admin" },
  "role.farmer": { ar: "مزارع", en: "Farmer" },
  "role.trader": { ar: "تاجر", en: "Trader" },
  "role.buyer": { ar: "مشترٍ", en: "Buyer" },
  "hub.kicker": { ar: "لوحة الحساب", en: "Account hub" },
  "hub.since": { ar: "عضو منذ", en: "Member since" },
  "hub.openWorkspace": { ar: "افتح اللوحة", en: "Open workspace" },
  "hub.openAdmin": { ar: "لوحة الإدارة", en: "Admin console" },
  "hub.open": { ar: "فتح", en: "Open" },
  "hub.payNow": { ar: "ادفع الآن", en: "Pay now" },
  "hub.kgSeason": { ar: "كجم موسم {y}", en: "kg in season {y}" },
  "hub.yields": { ar: "محاصيل", en: "yields" },
  "hub.certs": { ar: "شهادات سارية", en: "valid certs" },
  "hub.activeListings": { ar: "عروض نشطة", en: "Active listings" },
  "hub.awaitingDecision": { ar: "بانتظار قرارك", en: "awaiting your decision" },
  "hub.seasonNet": { ar: "صافي موسم {y}", en: "Season {y} net" },
  "hub.salesSeason": { ar: "مبيعات موسم {y}", en: "Season {y} sales" },
  "hub.activeBids": { ar: "مزايدات نشطة", en: "Active bids" },
  "hub.awaitingPayment": { ar: "بانتظار الدفع", en: "Awaiting payment" },
  "hub.purchases": { ar: "مشتريات مدفوعة", en: "Paid purchases" },
  "hub.users": { ar: "المستخدمون", en: "Users" },
  "hub.ordersMonth": { ar: "طلبات هذا الشهر", en: "Orders this month" },
  "hub.newYield.desc": { ar: "وثّق محصولاً جديداً وأصدر شهادته", en: "Certify a new harvest and issue its certificate" },
  "hub.alert.bank": { ar: "لديك مستحقات بانتظار التحويل ولم تُضِف بيانات حسابك البنكي", en: "You have pending payouts but no bank details on file" },
  "hub.alert.decision": { ar: "{n} مزاد منتهٍ بانتظار قبولك أو رفضك للفائز", en: "{n} ended auction(s) waiting for you to accept or decline the winner" },
  "hub.alert.ending": { ar: "{n} من عروضك ينتهي خلال 24 ساعة", en: "{n} of your listings end within 24 hours" },
  "hub.alert.access_pending": { ar: "طلب صلاحية المشتري قيد المراجعة", en: "Your buyer-access request is under review" },
  "hub.alert.pay": { ar: "{n} طلب بانتظار الدفع", en: "{n} order(s) awaiting payment" },
  "hub.alert.outbid": { ar: "تم تجاوز مزايدتك في {n} مزاد", en: "You've been outbid on {n} auction(s)" },
  "hub.alert.requests": { ar: "{n} طلب صلاحية مشتري بانتظار المراجعة", en: "{n} buyer-access request(s) pending review" },
  "hub.alert.verify": { ar: "احصل على علامة «تاجر موثّق» — أرسل سجلك التجاري للتحقق", en: "Get the Verified Trader mark — submit your CR for review" },
  "hub.alert.verify_pending": { ar: "طلب توثيق التاجر قيد المراجعة", en: "Your trader verification is under review" },
  "hub.alert.verifications": { ar: "{n} طلب توثيق تاجر بانتظار المراجعة", en: "{n} trader verification(s) awaiting review" },
  "wq.tab.farms": { ar: "المزارع", en: "Farms" },
  "po.status.paid": { ar: "مدفوع", en: "Paid" },
  "order.status.cancelled": { ar: "ملغي", en: "Cancelled" },
  "admin.status.valid": { ar: "صالحة", en: "Valid" },
  "a7.order": { ar: "الترتيب", en: "Order" },
  "a7.saveFail": { ar: "تعذّر الحفظ", en: "Could not save" },
  "a7.slugExists": { ar: "المعرّف (slug) مستخدم بالفعل", en: "This slug is already in use" },
  "a7.rows": { ar: "صف", en: "rows" },
  "a7.perPage": { ar: "لكل صفحة", en: "per page" },
  "a7.view": { ar: "عرض", en: "View" },
  "a7.related": { ar: "روابط ذات صلة", en: "Related" },
  "a7.editNA": { ar: "التعديل غير متاح لهذا العنصر", en: "Editing is not available for this item" },
  "admin.deleteTitle": { ar: "حذف العنصر؟", en: "Delete this item?" },
  "admin.draft": { ar: "مسودة", en: "Draft" },
  "admin.published": { ar: "منشور", en: "Published" },
  "admin.error": { ar: "حدث خطأ — حاول مجدداً", en: "Something went wrong — try again" },
  "admin.status": { ar: "الحالة", en: "Status" },
  "souq.ownListingNote": { ar: "هذا عرضك — لا يمكنك المزايدة عليه", en: "This is your own listing — you can't bid on it" },
  "err.NOT_FOUND": { ar: "غير موجود", en: "Not found" },
  "err.FORBIDDEN": { ar: "غير مصرّح لك", en: "You're not allowed to do that" },
  "err.INTERNAL_ERROR": { ar: "خطأ داخلي — حاول لاحقاً", en: "Internal error — please try later" },
  "err.BAD_PAYLOAD": { ar: "بيانات غير صالحة", en: "Invalid data" },
  "err.INVALID_ENUM": { ar: "قيمة غير صالحة", en: "Invalid value" },
  "err.INVALID_STATUS": { ar: "حالة غير صالحة", en: "Invalid status" },
  "err.INVALID_MONTH": { ar: "شهر غير صالح", en: "Invalid month" },
  "err.INVALID_SLUG": { ar: "معرّف غير صالح", en: "Invalid slug" },
  "err.INVALID_IMAGE": { ar: "صورة غير صالحة", en: "Invalid image" },
  "err.INVALID_SIDE": { ar: "قيمة غير صالحة", en: "Invalid side" },
  "err.INVALID_GROUP_BY": { ar: "تجميع غير صالح", en: "Invalid grouping" },
  "err.SLUG_EXISTS": { ar: "المعرّف مستخدم بالفعل", en: "Slug already exists" },
  "err.MEDIA_NOT_FOUND": { ar: "الوسيط غير موجود", en: "Media not found" },
  "err.REGION_NOT_FOUND": { ar: "المنطقة غير موجودة", en: "Region not found" },
  "err.YIELD_NOT_FOUND": { ar: "المحصول غير موجود", en: "Yield not found" },
  "err.UNKNOWN_CONTENT_TYPE": { ar: "نوع محتوى غير معروف", en: "Unknown content type" },
  "err.NOT_TRANSFERRED": { ar: "لم يتم تحويل هذه الدفعة", en: "This payout was not transferred" },
  "err.NO_PAID_ORDERS": { ar: "لا توجد طلبات مدفوعة", en: "No paid orders" },
  "err.ORDER_MISMATCH": { ar: "الطلب غير متطابق", en: "Order mismatch" },
  "err.BAD_WEBHOOK_SECRET": { ar: "سر الويب هوك غير صحيح", en: "Bad webhook secret" },
  "err.SEARCH_WARMING_UP": { ar: "البحث يستعد — حاول بعد لحظات", en: "Search is warming up — try again shortly" },
  "err.AI_UNAVAILABLE": { ar: "مساعد الذكاء غير متاح حالياً", en: "AI assistant is unavailable right now" },
  "err.LLM_UNAVAILABLE": { ar: "مساعد الذكاء غير متاح حالياً", en: "AI assistant is unavailable right now" },
  "err.AI_RATE_LIMIT": { ar: "طلبات كثيرة — انتظر قليلاً", en: "Too many requests — wait a moment" },
  "err.AI_BAD_OUTPUT": { ar: "استجابة غير صالحة من المساعد", en: "Unusable AI response" },

  "hub.welcome": { ar: "مرحباً", en: "Welcome" },
  "hub.farmer": { ar: "لوحة المزارع — وثيق", en: "Farmer dashboard — Watheeq" },
  "hub.farmer.desc": { ar: "المحاصيل، الشهادات، المزارع، التحليلات والتحويلات", en: "Yields, certificates, farms, analytics and payouts" },
  "hub.trader": { ar: "لوحة التاجر", en: "Trader dashboard" },
  "hub.trader.desc": { ar: "عروضك في السوق، الطلبات والتحويلات", en: "Your Souq listings, orders and payouts" },
  "hub.buyer": { ar: "مزايداتي ومشترياتي", en: "My bids & purchases" },
  "hub.buyer.desc": { ar: "تابع مزايداتك وادفع مشترياتك", en: "Track your bids and pay for your wins" },
  "hub.admin": { ar: "لوحة الإدارة", en: "Admin console" },
  "hub.admin.desc": { ar: "إدارة المنصة والمحتوى والسوق", en: "Manage platform, content and Souq" },
  "hub.souq": { ar: "تصفّح السوق", en: "Browse the Souq" },
  "hub.souq.desc": { ar: "المزادات النشطة على التمور السعودية", en: "Live auctions on Saudi dates" },
  "tr.kicker": { ar: "تاجر السوق", en: "Souq trader" },
  "tr.title": { ar: "عروضي في السوق", en: "My Souq listings" },
  "tr.tab.listings": { ar: "العروض والطلبات", en: "Listings & orders" },
  "tr.tab.payouts": { ar: "التحويلات", en: "Payouts" },
  "tr.tab.verification": { ar: "التوثيق", en: "Verification" },

  "tr.note": { ar: "عروض التجار تظهر بعلامة «عرض تاجر» ولا تحمل شارة وثيق الذهبية المخصصة لمحاصيل المزارعين الموثّقة.", en: "Trader listings carry a neutral 'Trader listing' mark — never the gold Watheeq badge reserved for certified farm yields." },
  "tr.quantity": { ar: "الكمية (كجم)", en: "Quantity (kg)" },
  "tr.origin": { ar: "منطقة المنشأ", en: "Origin region" },
  "adm.roles": { ar: "الأدوار", en: "Roles" },
  "adm.editRoles": { ar: "تعديل الأدوار", en: "Edit roles" },
  "adm.rolesTitle": { ar: "أدوار الحساب", en: "Account roles" },
  "adm.rolesDesc": { ar: "امنح أو أزل الأدوار. حساب واحد يمكنه حمل أكثر من دور.", en: "Grant or revoke roles. One account may hold several roles." },
  "adm.rolesSaved": { ar: "تم تحديث الأدوار", en: "Roles updated" },
  "ba.title": { ar: "صلاحية المشتري", en: "Buyer access" },
  "ba.desc": { ar: "اطلب صلاحية المزايدة والشراء الفوري على محاصيل المزارع الأخرى. لا يمكن المزايدة على مزاداتك أبداً.", en: "Request permission to bid and Buy-Now on other farms' harvests. Bidding on your own listings is never allowed." },
  "ba.status.none": { ar: "غير مفعّلة", en: "Not enabled" },
  "ba.status.pending": { ar: "قيد المراجعة", en: "Pending review" },
  "ba.status.approved": { ar: "مفعّلة", en: "Approved" },
  "ba.status.rejected": { ar: "مرفوضة", en: "Rejected" },
  "ba.status.revoked": { ar: "ملغاة", en: "Revoked" },
  "ba.reason": { ar: "السبب", en: "Reason" },
  "ba.request": { ar: "طلب صلاحية المشتري", en: "Request buyer access" },
  "ba.requestDesc": { ar: "سيراجع فريق المنصة طلبك ويُعلمك بالنتيجة هنا.", en: "The platform team reviews your request; the outcome shows here." },
  "ba.note": { ar: "ملاحظة (اختياري)", en: "Note (optional)" },
  "ba.send": { ar: "إرسال الطلب", en: "Send request" },
  "ba.sent": { ar: "تم إرسال الطلب", en: "Request sent" },
  "ba.myBuying": { ar: "مزايداتي ومشترياتي", en: "My bids & purchases" },
  "ba.browse": { ar: "تصفّح السوق", en: "Browse the Souq" },
  "ba.adminTitle": { ar: "طلبات صلاحية المشتري", en: "Buyer access requests" },
  "a7.nav.buyer-requests": { ar: "طلبات المشترين", en: "Buyer Requests" },
  "ba.approve": { ar: "قبول", en: "Approve" },
  "ba.reject": { ar: "رفض", en: "Reject" },
  "ba.approveTitle": { ar: "قبول طلب صلاحية المشتري", en: "Approve buyer access" },
  "ba.rejectTitle": { ar: "رفض طلب صلاحية المشتري", en: "Reject buyer access" },
  "ba.reasonOptional": { ar: "سبب / ملاحظة للمزارع (اختياري)", en: "Reason / note to the farmer (optional)" },
  "ba.approvedOk": { ar: "تم تفعيل صلاحية المشتري", en: "Buyer privilege granted" },
  "ba.rejectedOk": { ar: "تم رفض الطلب", en: "Request rejected" },
  "ba.revokedOk": { ar: "تم إلغاء صلاحية المشتري", en: "Buyer privilege revoked" },
  "ba.column": { ar: "صلاحية المشتري", en: "Buyer privilege" },
  "ba.roleBuyer": { ar: "مشترٍ", en: "Buyer" },
  "ba.roleAdmin": { ar: "مدير", en: "Admin" },
  "ba.grant": { ar: "منح صلاحية المشتري", en: "Grant buyer access" },
  "ba.revoke": { ar: "إلغاء الصلاحية", en: "Revoke" },
  "ba.grantTitle": { ar: "منح صلاحية المشتري مباشرة؟", en: "Grant buyer privilege directly?" },
  "ba.grantDesc": { ar: "سيتمكن هذا المزارع من المزايدة على محاصيل المزارع الأخرى", en: "This farmer will be able to bid on other farms' listings" },
  "ba.revokeTitle": { ar: "إلغاء صلاحية المشتري؟", en: "Revoke buyer privilege?" },
  "ba.revokeDesc": { ar: "لن يتمكن من المزايدة أو الشراء الفوري بعد الآن", en: "They will no longer be able to bid or Buy-Now" },
  "le.edit": { ar: "تعديل", en: "Edit" },
  "le.title": { ar: "تعديل المزاد (إداري)", en: "Edit listing (admin)" },
  "le.save": { ar: "حفظ التعديلات", en: "Save changes" },
  "le.saved": { ar: "تم حفظ التعديلات وتسجيلها", en: "Changes saved & logged" },
  "le.guard": { ar: "يوجد مزايدات: لا يمكن خفض سعر البداية تحت أعلى مزايدة، ويجب أن يبقى سعر الشراء الفوري أعلى من السعر الحالي.", en: "Has bids: starting price cannot go below the highest bid and Buy-Now must stay above the current price." },
  "le.endsAt": { ar: "وقت الانتهاء", en: "End time" },
  "le.descAr": { ar: "الوصف (عربي)", en: "Description (Arabic)" },
  "le.descEn": { ar: "الوصف (إنجليزي)", en: "Description (English)" },
  "le.bidsUnmasked": { ar: "سجل المزايدات (هويات كاملة — للإدارة فقط)", en: "Bid history (unmasked — admin only)" },
  "le.changeLog": { ar: "سجل التعديلات", en: "Change history" },
  "le.noChanges": { ar: "لا تعديلات إدارية", en: "No admin edits yet" },
  "le.field.desc_ar": { ar: "الوصف (عربي)", en: "Description (AR)" },
  "le.field.desc_en": { ar: "الوصف (إنجليزي)", en: "Description (EN)" },
  "le.field.starting_price": { ar: "سعر البداية", en: "Starting price" },
  "le.field.buy_now_price": { ar: "الشراء الفوري", en: "Buy-Now price" },
  "le.field.ends_at": { ar: "وقت الانتهاء", en: "End time" },
  "err.FARMERS_ONLY": { ar: "هذه الخاصية متاحة للمزارعين فقط", en: "Only farmers can do this" },
  "err.BID_TOO_LOW": { ar: "المزايدة أقل من الحد الأدنى", en: "Bid is below the minimum" },
  "err.LISTING_NOT_ACTIVE": { ar: "هذا المزاد لم يعد نشطاً", en: "This auction is no longer active" },
  "err.LISTING_NOT_FOUND": { ar: "المزاد غير موجود", en: "Listing not found" },
  "err.YIELD_ALREADY_LISTED": { ar: "هذا المحصول معروض في مزاد نشط بالفعل", en: "This yield already has an active listing" },
  "err.BUY_NOW_TOO_LOW": { ar: "سعر الشراء الفوري يجب أن يتجاوز سعر البداية", en: "Buy Now price must exceed the starting price" },
  "err.LISTING_HAS_BIDS": { ar: "لا يمكن إلغاء مزاد عليه مزايدات", en: "You can't cancel a listing that has bids" },
  "err.NOTHING_TO_ACCEPT": { ar: "لا يوجد عرض فائز بانتظار القبول", en: "No winning bid awaiting acceptance" },
  "err.NO_BUY_NOW": { ar: "هذا المزاد لا يوفر شراءً فورياً", en: "This auction has no Buy Now option" },
  "err.ALREADY_SOLD": { ar: "هذا المزاد مُباع بالفعل", en: "This listing is already sold" },
  "err.INVALID_DURATION": { ar: "مدة المزاد يجب أن تكون 3 أو 7 أو 14 يوماً", en: "Duration must be 3, 7 or 14 days" },
  "err.VALIDATION": { ar: "تحقق من صحة البيانات المدخلة", en: "Please check the entered details" },

  "settings.statLink": { ar: "رابط (اختياري)", en: "Link (optional)" },
  "a7.sortHint": { ar: "انقر لترتيب العمود", en: "Click to sort" },
  "media.editCaption": { ar: "تعديل التسمية", en: "Edit caption" },
  "media.caption": { ar: "التسمية (Caption)", en: "Caption" },
  "media.saved": { ar: "تم حفظ التسمية", en: "Caption saved" },
  "kn.link": { ar: "رابط الصفحة المرتبطة (مثال: /varieties/ajwa)", en: "Linked page path (e.g. /varieties/ajwa)" },
  "kn.linkInvalid": { ar: "يجب أن يبدأ الرابط بـ /", en: "Path must start with /" },
  "settings.homeStats": { ar: "شريط الأرقام في الصفحة الرئيسية", en: "Homepage stats band" },
  "settings.statNum": { ar: "الرقم", en: "Number" },
  "settings.statLabelAr": { ar: "الوصف (عربي)", en: "Label (Arabic)" },
  "settings.statLabelEn": { ar: "الوصف (إنجليزي)", en: "Label (English)" },
  "settings.addStat": { ar: "إضافة رقم", en: "Add stat" },
  "verify.status.valid": { ar: "موثّقة", en: "VERIFIED" },
  "verify.status.revoked": { ar: "ملغاة", en: "REVOKED" },
  "verify.status.notfound": { ar: "غير موجودة", en: "NOT FOUND" },
  "verify.checkedAt": { ar: "وقت التحقق (خادم وثيق)", en: "Checked at (Watheeq server)" },
  "verify.issuer": { ar: "الجهة المُصدِرة", en: "Issuer" },
  "verify.issuerName": { ar: "وثيق — واحة التمور", en: "Watheeq — Dates Oasis" },
  "verify.issuerDesc": { ar: "سجل محصول رقمي موثّق جغرافياً، يُتحقق منه مباشرة من خادم المُصدِر ولا يمكن تعديله من قبل حامل الشهادة.", en: "A geo-verified digital provenance record, checked live against the issuer's server and not editable by the certificate holder." },
  "verify.recordId": { ar: "رقم السجل", en: "Record ID" },
  "verify.status": { ar: "الحالة", en: "Status" },
  "verify.details": { ar: "بيانات الشهادة", en: "Certificate details" },
  "verify.location": { ar: "موقع المزرعة", en: "Farm location" },
  "verify.print": { ar: "طباعة", en: "Print" },
  "verify.copy": { ar: "نسخ رابط التحقق", en: "Copy verify link" },
  "verify.copied": { ar: "تم النسخ", en: "Copied" },
  "verify.howTitle": { ar: "كيف تتحقق؟", en: "How to verify" },
  "verify.how1": { ar: "تأكد أن عنوان الصفحة يبدأ بنطاق واحة التمور الرسمي.", en: "Check that the page address starts with the official Dates Oasis domain." },
  "verify.how2": { ar: "قارن رقم السجل مع الرقم المطبوع على الشهادة الورقية.", en: "Compare the record ID with the one printed on the paper certificate." },
  "verify.how3": { ar: "الحالة تُقرأ لحظياً من خادم المُصدِر — أي إلغاء يظهر فوراً.", en: "Status is read live from the issuer's server — any revocation shows instantly." },
  "verify.revokedAt": { ar: "تاريخ الإلغاء", en: "Revoked on" },
  "verify.mapCaption": { ar: "معاينة ثابتة — © مساهمو OpenStreetMap", en: "Static preview — © OpenStreetMap contributors" },
  "err.RATE_LIMITED": { ar: "محاولات كثيرة — انتظر دقيقة ثم أعد المحاولة", en: "Too many attempts — wait a minute and retry" },
  "err.ACCOUNT_LOCKED": { ar: "الحساب مقفل مؤقتاً بعد محاولات فاشلة — حاول بعد 15 دقيقة", en: "Account temporarily locked after failed attempts — try again in 15 minutes" },
  "err.INVALID_VARIETY": { ar: "اختر صنفاً صحيحاً", en: "Choose a valid variety" },
  "err.INVALID_DATE": { ar: "صيغة التاريخ غير صحيحة", en: "Invalid date format" },
  "err.FUTURE_HARVEST_DATE": { ar: "تاريخ الحصاد لا يمكن أن يكون في المستقبل", en: "Harvest date cannot be in the future" },
  "err.OUT_OF_SAUDI": { ar: "الإحداثيات خارج حدود المملكة العربية السعودية", en: "Coordinates are outside Saudi Arabia" },
  "err.NOT_AUTHENTICATED": { ar: "الرجاء تسجيل الدخول", en: "Please log in" },

  // Dashboard
  "dash.welcome": { ar: "مرحباً", en: "Welcome" },
  "dash.stats.yields": { ar: "المحاصيل المسجلة", en: "Registered Yields" },
  "dash.stats.kg": { ar: "إجمالي الكمية (كغ)", en: "Total Quantity (kg)" },
  "dash.stats.certs": { ar: "الشهادات الصادرة", en: "Certificates Issued" },
  "dash.new_yield": { ar: "تسجيل محصول جديد", en: "Submit New Yield" },
  "dash.your_yields": { ar: "محاصيلك وشهاداتها", en: "Your Yields & Certificates" },
  "dash.empty": { ar: "لا محاصيل بعد — سجّل أول محصول لك", en: "No yields yet — submit your first one" },
  "dash.logout": { ar: "خروج", en: "Log out" },
  "dash.download": { ar: "تحميل الشهادة", en: "Download Certificate" },
  "dash.status.certified": { ar: "موثق", en: "Certified" },
  "dash.harvest": { ar: "الحصاد", en: "Harvest" },
  "dash.loading": { ar: "جاري التحميل...", en: "Loading..." },

  // Yield form
  "yf.variety": { ar: "الصنف", en: "Variety" },
  "yf.variety_ph": { ar: "اختر الصنف", en: "Select variety" },
  "yf.quantity": { ar: "الكمية (كغ)", en: "Quantity (kg)" },
  "yf.harvest": { ar: "تاريخ الحصاد", en: "Harvest date" },
  "yf.location": { ar: "موقع المزرعة — انقر أو اسحب الدبوس الذهبي", en: "Farm location — click or drag the gold pin" },
  "yf.lat": { ar: "خط العرض", en: "Latitude" },
  "yf.lng": { ar: "خط الطول", en: "Longitude" },
  "yf.uselocation": { ar: "استخدم موقعي", en: "Use my location" },
  "yf.geo_error": { ar: "تعذر تحديد موقعك", en: "Couldn't get your location" },
  "yf.notes": { ar: "ملاحظات (اختياري)", en: "Notes (optional)" },
  "yf.submit": { ar: "إصدار الشهادة", en: "Submit & Certify" },
  "yf.submitting": { ar: "جاري الإصدار...", en: "Certifying..." },
  "yf.success": { ar: "تم توثيق المحصول وإصدار الشهادة!", en: "Yield certified — certificate issued!" },

  // Verify page
  "verify.loading": { ar: "جاري التحقق من الشهادة...", en: "Verifying certificate..." },
  "verify.valid": { ar: "شهادة موثقة", en: "Verified Certificate" },
  "verify.valid_sub": { ar: "هذه الشهادة صادرة رسمياً من واحة التمور", en: "This certificate is officially issued by Dates Oasis" },
  "verify.invalid_title": { ar: "الشهادة غير موجودة", en: "Certificate Not Found" },
  "verify.invalid_desc": {
    ar: "لم نعثر على شهادة بهذا الرقم — تأكد من الرمز أو الرابط",
    en: "No certificate matches this ID — check the code or link",
  },
  "verify.farmer": { ar: "المزارع", en: "Farmer" },
  "verify.farm": { ar: "المزرعة", en: "Farm" },
  "verify.variety": { ar: "الصنف", en: "Variety" },
  "verify.quantity": { ar: "الكمية", en: "Quantity" },
  "verify.region": { ar: "المنطقة", en: "Region" },
  "verify.harvest": { ar: "تاريخ الحصاد", en: "Harvest date" },
  "verify.issued": { ar: "تاريخ الإصدار", en: "Issued" },
  "verify.coords": { ar: "الإحداثيات", en: "Coordinates" },
  "verify.back_home": { ar: "الصفحة الرئيسية", en: "Back home" },
  "verify.view_map": { ar: "استكشف المنطقة على الخريطة", en: "Explore the region on the map" },

  // Meta / route titles (Phase 4)
  "meta.desc": {
    ar: "واحة التمور — منصة تراثية فاخرة لثقافة التمور السعودية: خريطة ثلاثية الأبعاد، بحث معرفي ذكي، وشهادات محصول موثقة برمز QR",
    en: "Dates Oasis — a luxury heritage platform for Saudi date culture: 3D heritage map, AI knowledge search, and QR-verified provenance certificates",
  },
  "title.home": { ar: "إرث النخيل السعودي", en: "The Saudi Palm Legacy" },
  "title.map": { ar: "خريطة التراث", en: "Heritage Map" },
  "title.knowledge": { ar: "بحث المعرفة", en: "Knowledge Search" },
  "title.provenance": { ar: "وثيق — توثيق محصول التمور", en: "Watheeq — Origin Trust" },
  "title.dashboard": { ar: "وثيق — لوحة المزارع", en: "Watheeq — Farmer Dashboard" },
  "title.auth": { ar: "الدخول والتسجيل", en: "Sign in / Sign up" },
  "title.verify": { ar: "التحقق من الشهادة", en: "Certificate Verification" },
  "title.poc": { ar: "النموذج التقني", en: "Technical POC" },
  "title.notfound": { ar: "الصفحة غير موجودة", en: "Page Not Found" },
  "title.hub": { ar: "لوحة الحساب", en: "Account Hub" },
  "title.trader": { ar: "لوحة التاجر", en: "Trader Dashboard" },
  "title.buyer": { ar: "لوحة المشتري", en: "Buyer Dashboard" },
  "title.payment": { ar: "نتيجة الدفع", en: "Payment Result" },
  "xl.varietyPage": { ar: "صفحة الصنف", en: "Variety page" },
  "xl.regionPage": { ar: "بوابة المنطقة", en: "Region page" },
  "xl.liveSouq": { ar: "مباشر في السوق", en: "Live in the Souq" },
  "xl.liveSouqSub": { ar: "مزادات نشطة لهذا الصنف الآن", en: "Active auctions for this variety right now" },
  "xl.allOfVariety": { ar: "كل مزادات {v} في السوق", en: "All {v} auctions in the Souq" },
  "xl.growsIn": { ar: "تُزرع في", en: "Grows in" },
  "xl.filterChip": { ar: "تعرّف على", en: "Learn about" },


  // 404
  "nf.title": { ar: "الصفحة غير موجودة", en: "Page Not Found" },
  "nf.desc": {
    ar: "يبدو أنك ضللت الطريق في الصحراء — الصفحة التي تبحث عنها غير موجودة",
    en: "You seem to have wandered off the caravan trail — this page doesn't exist",
  },
  "nf.home": { ar: "العودة إلى الواحة", en: "Back to the Oasis" },

  // Extra auth error codes
  "err.TOKEN_EXPIRED": { ar: "انتهت صلاحية الجلسة — سجّل الدخول مجدداً", en: "Session expired — please log in again" },
  "err.INVALID_TOKEN": { ar: "جلسة غير صالحة — سجّل الدخول مجدداً", en: "Invalid session — please log in again" },
  "err.USER_NOT_FOUND": { ar: "الحساب غير موجود — سجّل الدخول مجدداً", en: "Account not found — please log in again" },

  // Phase 5 — verify revoked state
  "verify.revoked": { ar: "شهادة ملغاة", en: "REVOKED Certificate" },
  "verify.revoked_sub": {
    ar: "تم إلغاء هذه الشهادة من قبل إدارة المنصة ولم تعد سارية",
    en: "This certificate has been revoked by platform administration and is no longer valid",
  },
  "verify.revoked_reason": { ar: "سبب الإلغاء", en: "Revocation reason" },
  "title.admin": { ar: "لوحة الإدارة", en: "Admin Portal" },

  // Phase 5 — admin errors
  "err.ADMIN_ONLY": { ar: "هذه الصفحة مخصصة لإدارة المنصة فقط", en: "This area is restricted to platform administrators" },
  "err.ACCOUNT_DISABLED": { ar: "تم تعطيل هذا الحساب — تواصل مع الإدارة", en: "This account has been deactivated — contact administration" },
  "err.DOC_NOT_FOUND": { ar: "الوثيقة غير موجودة", en: "Document not found" },
  "err.CERT_NOT_FOUND": { ar: "الشهادة غير موجودة", en: "Certificate not found" },
  "err.LOC_NOT_FOUND": { ar: "الموقع غير موجود", en: "Location not found" },
  "err.ROUTE_NOT_FOUND": { ar: "الطريق غير موجود", en: "Route not found" },
  "err.INVALID_WAYPOINTS": { ar: "نقاط المسار غير صالحة (نقطتان إلى 50، lng,lat)", en: "Invalid waypoints (2-50 points, lng,lat)" },
  "err.INVALID_TYPE": { ar: "نوع الموقع غير صالح", en: "Invalid location type" },

  // Phase 5 — admin portal UI
  "admin.login_title": { ar: "دخول إدارة المنصة", en: "Platform Admin Login" },
  "admin.title": { ar: "لوحة إدارة واحة التمور", en: "Dates Oasis Admin" },
  "admin.denied_title": { ar: "غير مصرح", en: "Access Denied" },
  "admin.denied_desc": { ar: "هذه المنطقة مخصصة لإدارة المنصة فقط", en: "This area is restricted to platform administrators" },
  "admin.logout": { ar: "خروج", en: "Log out" },
  "admin.loading": { ar: "جاري التحميل...", en: "Loading..." },
  "admin.tab.dashboard": { ar: "الرئيسية", en: "Dashboard" },
  "admin.tab.farmers": { ar: "المزارعون", en: "Farmers" },
  "admin.tab.yields": { ar: "المحاصيل والشهادات", en: "Yields & Certs" },
  "admin.tab.knowledge": { ar: "وثائق المعرفة", en: "Knowledge" },
  "admin.tab.mapdata": { ar: "بيانات الخريطة", en: "Map Data" },
  "admin.stats.farmers": { ar: "المزارعون", en: "Farmers" },
  "admin.stats.yields": { ar: "المحاصيل", en: "Yields" },
  "admin.stats.kg": { ar: "إجمالي الكيلوغرامات", en: "Total kg" },
  "admin.stats.valid": { ar: "شهادات سارية", en: "Valid certs" },
  "admin.stats.revoked": { ar: "شهادات ملغاة", en: "Revoked certs" },
  "admin.stats.docs": { ar: "وثائق المعرفة", en: "Knowledge docs" },
  "admin.recent_yields": { ar: "أحدث المحاصيل", en: "Latest yields" },
  "admin.recent_farmers": { ar: "أحدث التسجيلات", en: "Latest registrations" },
  "admin.search_ph": { ar: "ابحث بالاسم أو البريد أو المزرعة...", en: "Search name, email, farm..." },
  "admin.col.joined": { ar: "الانضمام", en: "Joined" },
  "admin.col.yields": { ar: "المحاصيل", en: "Yields" },
  "admin.active": { ar: "نشط", en: "Active" },
  "admin.inactive": { ar: "معطل", en: "Inactive" },
  "admin.deactivate": { ar: "تعطيل", en: "Deactivate" },
  "admin.reactivate": { ar: "تفعيل", en: "Reactivate" },
  "admin.details": { ar: "التفاصيل", en: "Details" },
  "admin.filter.all": { ar: "الكل", en: "All" },
  "admin.filter.variety": { ar: "الصنف", en: "Variety" },
  "admin.filter.status": { ar: "الحالة", en: "Status" },
  "admin.revoke": { ar: "إلغاء الشهادة", en: "Revoke" },
  "admin.reinstate": { ar: "إعادة التفعيل", en: "Reinstate" },
  "admin.revoke_reason_ph": { ar: "سبب الإلغاء (اختياري)", en: "Revocation reason (optional)" },
  "admin.confirm_revoke": { ar: "تأكيد الإلغاء", en: "Confirm revoke" },
  "admin.download": { ar: "PDF", en: "PDF" },
  "admin.status.certified": { ar: "موثق", en: "Certified" },
  "admin.status.revoked": { ar: "ملغاة", en: "Revoked" },
  "admin.new": { ar: "إضافة جديد", en: "Add new" },
  "admin.edit": { ar: "تعديل", en: "Edit" },
  "admin.delete": { ar: "حذف", en: "Delete" },
  "admin.save": { ar: "حفظ", en: "Save" },
  "admin.cancel": { ar: "إلغاء", en: "Cancel" },
  "admin.saving": { ar: "جاري الحفظ...", en: "Saving..." },
  "admin.saved": { ar: "تم الحفظ — البحث والخريطة محدثان", en: "Saved — search & map updated" },
  "admin.deleted": { ar: "تم الحذف", en: "Deleted" },
  "admin.confirm_delete": { ar: "متأكد من الحذف؟ اضغط مرة أخرى", en: "Sure? Click again to delete" },
  "admin.kn.title_ar": { ar: "العنوان (عربي)", en: "Title (Arabic)" },
  "admin.kn.title_en": { ar: "العنوان (إنجليزي)", en: "Title (English)" },
  "admin.kn.text_ar": { ar: "النص (عربي)", en: "Text (Arabic)" },
  "admin.kn.text_en": { ar: "النص (إنجليزي)", en: "Text (English)" },
  "admin.kn.category": { ar: "التصنيف", en: "Category" },
  "admin.loc.locations": { ar: "المواقع", en: "Locations" },
  "admin.loc.routes": { ar: "الطرق التجارية", en: "Trade routes" },
  "admin.loc.type": { ar: "النوع", en: "Type" },
  "admin.loc.fact": { ar: "الحقيقة البارزة", en: "Hero fact" },
  "admin.loc.desc": { ar: "الوصف", en: "Description" },
  "admin.loc.varieties": { ar: "الأصناف (بفاصلة)", en: "Varieties (comma-sep)" },
  "admin.route.poi": { ar: "معلم بارز", en: "Point of interest" },
  "admin.route.waypoints": { ar: "نقاط المسار — سطر لكل نقطة: lng,lat", en: "Waypoints — one per line: lng,lat" },
};

export const VARIETIES = [
  {
    id: "ajwa",
    img: "/images/ajwa.webp",
    name: { ar: "عجوة", en: "Ajwa" },
    region: { ar: "المدينة المنورة", en: "Al-Madinah" },
    desc: {
      ar: "تمرة داكنة طرية القوام بحلاوة جافة رقيقة، ارتبطت بالطب النبوي وتُعد أنفس تمور العالم الإسلامي.",
      en: "A dark, tender date with a delicate dry sweetness, tied to prophetic medicine and prized across the Islamic world.",
    },
    traits: {
      ar: ["بني داكن", "قوام طري", "حلاوة جافة", "إرث طبي"],
      en: ["Dark brown", "Soft texture", "Dry sweetness", "Medicinal legacy"],
    },
  },
  {
    id: "khalas",
    img: "/images/khalas.webp",
    name: { ar: "خلاص", en: "Khalas" },
    region: { ar: "الأحساء والقصيم", en: "Al-Ahsa & Al-Qassim" },
    desc: {
      ar: "كهرمانية اللون عالية الرطوبة بنكهة كراميل غنية، جوهرة الموائد في شرق المملكة.",
      en: "Amber-hued and high in moisture with a rich caramel flavor — the jewel of eastern Arabian tables.",
    },
    traits: {
      ar: ["كهرماني", "رطوبة عالية", "نكهة كراميل", "توازن فاخر"],
      en: ["Amber", "High moisture", "Caramel notes", "Refined balance"],
    },
  },
  {
    id: "sukkari",
    img: "/images/sukkari.webp",
    name: { ar: "سكري", en: "Sukkari" },
    region: { ar: "القصيم", en: "Al-Qassim" },
    desc: {
      ar: "ذهبية اللون فائقة الحلاوة كما يوحي اسمها، مقرمشة جافة وذائبة رطبة — فخر تمور القصيم.",
      en: "Golden and exceptionally sweet as its name suggests — crisp when dry, melting when soft. The pride of Al-Qassim.",
    },
    traits: {
      ar: ["ذهبي", "حلاوة استثنائية", "مقرمش/ذائب", "الأكثر طلباً"],
      en: ["Golden", "Exceptional sweetness", "Crisp / melting", "Most sought-after"],
    },
  },
];

export const CULINARY = [
  {
    id: "hinney",
    img: "/images/hinney.webp",
    name: { ar: "حنيني", en: "Hinney" },
    traditional: {
      ar: "تمر منزوع النوى يُعجن مع خبز البر والسمن البلدي، يُقدَّم دافئاً في ليالي الشتاء النجدية.",
      en: "Pitted dates kneaded with brown wheat bread and ghee, served warm through cold Najdi winter nights.",
    },
    modern: {
      ar: "ميل فاي مفكك: طبقات من كريمة التمر المكرمل بين رقائق البر المحمّصة وذهب صالح للأكل.",
      en: "A deconstructed mille-feuille: caramelized date cream layered between toasted wheat crisps and edible gold.",
    },
  },
  {
    id: "klaitcha",
    img: "/images/klaitcha.webp",
    name: { ar: "كليجة", en: "Klaitcha" },
    traditional: {
      ar: "بسكويت محشو بمعجون التمر والهيل، تفوح رائحته من أفران البيوت في الأعياد والمواسم.",
      en: "A date-paste-filled biscuit scented with cardamom, baked in home ovens for feasts and seasons.",
    },
    modern: {
      ar: "ماكرون التمر المتبّل: قشرة لوز هشة تحتضن غاناش تمرٍ بالهيل والزعفران.",
      en: "A spiced date macaron: delicate almond shells embracing a date ganache of cardamom and saffron.",
    },
  },
];

export const STATS = [
  { num: "2.5M", key: "stats.palms" },
  { num: "#1", key: "stats.festival" },
  { num: "2", key: "stats.routes" },
];
